import { Lines_$007CTrimParagraphLines$007C, StringPosition_$007CStartsWithWrapped$007C_$007C, Lines_$007CTrimBlankStart$007C, StringPosition_$007CStartsWith$007C_$007C, StringPosition_$007CStartsAndEndsWith$007C_$007C, StringPosition_$007CUnindented$007C_$007C, StringPosition_$007CWhiteSpace$007C_$007C, StringPosition_$007CStartsWithAny$007C_$007C, StringPosition_$007CTrimStartAndCount$007C, $007CLet$007C, StringPosition_$007CStartsWithNTimesTrimIgnoreStartWhitespace$007C_$007C, Lines_$007CTrimBlank$007C, Lines_$007CTakeCodeBlock$007C_$007C, StringPosition_$007CEqualsRepeated$007C_$007C, StringPosition_$007CTrimEnd$007C, StringPosition_$007CStartsWithRepeated$007C_$007C, List_$007CAsString$007C, List_$007CBracketDelimited$007C_$007C, StringPosition_$007CTrimBoth$007C } from "./StringParsing.fs.js";
import { printf, toFail, join, split, isNullOrWhiteSpace, replicate, getCharAtIndex, endsWith, isNullOrEmpty, trimStart, trimEnd, substring } from "../fable-library.3.7.20/String.js";
import { zip, replicate as replicate_1, forAll as forAll_1, choose, skipWhile, map, takeWhile, initialize, ofSeq, append as append_1, splitAt, toArray, singleton, ofArray, length, skip, empty, cons, reverse, ofArrayWithTail, tail, head, isEmpty } from "../fable-library.3.7.20/List.js";
import { exists, empty as empty_1, toArray as toArray_1, take, tryFind, collect, toList, forAll, singleton as singleton_1, append, delay, tryPick } from "../fable-library.3.7.20/Seq.js";
import { List_nestUnderLastMatching, Tree$1, Tree_ofIndentedList, List_partitionWhileLookahead, List_partitionUntilLookahead, List_partitionUntil, List_partitionWhile, List_partitionUntilEquals } from "./Collections.fs.js";
import { MarkdownParagraph, MarkdownColumnAlignment, MarkdownListKind, MarkdownSpan } from "./MarkdownModel.fs.js";
import { create, match } from "../fable-library.3.7.20/RegExp.js";
import { FSharpRef, Record } from "../fable-library.3.7.20/Types.js";
import { record_type, enum_type, int32_type, bool_type, class_type, tuple_type, option_type, string_type } from "../fable-library.3.7.20/Reflection.js";
import { MarkdownRangeModule_mergeRanges, MarkdownRangeModule_zero, MarkdownRange, MarkdownRange$reflection } from "./Range.fs.js";
import { equals, Lazy } from "../fable-library.3.7.20/Util.js";
import { isDigit, isWhiteSpace } from "../fable-library.3.7.20/Char.js";
import { map as map_1 } from "../fable-library.3.7.20/Array.js";
import { some, value as value_14 } from "../fable-library.3.7.20/Option.js";
import { rangeDouble } from "../fable-library.3.7.20/Range.js";
import { addToDict } from "../fable-library.3.7.20/MapUtil.js";

export function getLinkAndTitle(_arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    const input = StringPosition_$007CTrimBoth$007C(_arg[0], _arg[1])[0];
    let patternInput;
    if (input.length === 0) {
        patternInput = ["", void 0];
    }
    else {
        const c = input[input.length - 1];
        if ((c === "\u0027") ? true : (c === "\"")) {
            const start = input.indexOf(c) | 0;
            patternInput = [substring(input, 0, start).trim(), substring(input, start + 1, (input.length - 2) - start).trim()];
        }
        else {
            patternInput = [input, void 0];
        }
    }
    return [trimEnd(trimStart(patternInput[0], "\u003c"), "\u003e"), patternInput[1]];
}

export function $007CDelimitedMarkdown$007C_$007C(bracket, input) {
    let loop_2;
    const loop = (acc_mut, _arg_mut) => {
        let loop_1;
        loop:
        while (true) {
            const acc = acc_mut, _arg = _arg_mut;
            let activePatternResult;
            const input_1 = _arg;
            let pattern_matching_result, c, rest;
            if (!isEmpty(input_1)) {
                if (head(input_1) === "\\") {
                    if (!isEmpty(tail(input_1))) {
                        if (head(tail(input_1)) === "!") {
                            pattern_matching_result = 0;
                            c = head(tail(input_1));
                            rest = tail(tail(input_1));
                        }
                        else if (head(tail(input_1)) === "#") {
                            pattern_matching_result = 0;
                            c = head(tail(input_1));
                            rest = tail(tail(input_1));
                        }
                        else if (head(tail(input_1)) === "$") {
                            pattern_matching_result = 0;
                            c = head(tail(input_1));
                            rest = tail(tail(input_1));
                        }
                        else if (head(tail(input_1)) === "(") {
                            pattern_matching_result = 0;
                            c = head(tail(input_1));
                            rest = tail(tail(input_1));
                        }
                        else if (head(tail(input_1)) === ")") {
                            pattern_matching_result = 0;
                            c = head(tail(input_1));
                            rest = tail(tail(input_1));
                        }
                        else if (head(tail(input_1)) === "*") {
                            pattern_matching_result = 0;
                            c = head(tail(input_1));
                            rest = tail(tail(input_1));
                        }
                        else if (head(tail(input_1)) === "+") {
                            pattern_matching_result = 0;
                            c = head(tail(input_1));
                            rest = tail(tail(input_1));
                        }
                        else if (head(tail(input_1)) === "-") {
                            pattern_matching_result = 0;
                            c = head(tail(input_1));
                            rest = tail(tail(input_1));
                        }
                        else if (head(tail(input_1)) === ".") {
                            pattern_matching_result = 0;
                            c = head(tail(input_1));
                            rest = tail(tail(input_1));
                        }
                        else if (head(tail(input_1)) === "\u003e") {
                            pattern_matching_result = 0;
                            c = head(tail(input_1));
                            rest = tail(tail(input_1));
                        }
                        else if (head(tail(input_1)) === "[") {
                            pattern_matching_result = 0;
                            c = head(tail(input_1));
                            rest = tail(tail(input_1));
                        }
                        else if (head(tail(input_1)) === "\\") {
                            pattern_matching_result = 0;
                            c = head(tail(input_1));
                            rest = tail(tail(input_1));
                        }
                        else if (head(tail(input_1)) === "]") {
                            pattern_matching_result = 0;
                            c = head(tail(input_1));
                            rest = tail(tail(input_1));
                        }
                        else if (head(tail(input_1)) === "_") {
                            pattern_matching_result = 0;
                            c = head(tail(input_1));
                            rest = tail(tail(input_1));
                        }
                        else if (head(tail(input_1)) === "`") {
                            pattern_matching_result = 0;
                            c = head(tail(input_1));
                            rest = tail(tail(input_1));
                        }
                        else if (head(tail(input_1)) === "{") {
                            pattern_matching_result = 0;
                            c = head(tail(input_1));
                            rest = tail(tail(input_1));
                        }
                        else if (head(tail(input_1)) === "}") {
                            pattern_matching_result = 0;
                            c = head(tail(input_1));
                            rest = tail(tail(input_1));
                        }
                        else {
                            pattern_matching_result = 1;
                        }
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
            switch (pattern_matching_result) {
                case 0: {
                    activePatternResult = [c, rest];
                    break;
                }
                case 1: {
                    activePatternResult = (void 0);
                    break;
                }
            }
            if (activePatternResult != null) {
                const x_2 = activePatternResult[0];
                const xs_2 = activePatternResult[1];
                acc_mut = ofArrayWithTail([x_2, "\\"], acc);
                _arg_mut = xs_2;
                continue loop;
            }
            else if ((loop_1 = ((start_1_mut, list_1_mut) => {
                loop_1:
                while (true) {
                    const start_1 = start_1_mut, list_1 = list_1_mut;
                    const matchValue = [start_1, list_1];
                    let pattern_matching_result_1, x_1, xs_1, y_1, ys_1;
                    if (isEmpty(matchValue[0])) {
                        pattern_matching_result_1 = 1;
                    }
                    else if (!isEmpty(matchValue[1])) {
                        if (head(matchValue[0]) === head(matchValue[1])) {
                            pattern_matching_result_1 = 0;
                            x_1 = head(matchValue[0]);
                            xs_1 = tail(matchValue[0]);
                            y_1 = head(matchValue[1]);
                            ys_1 = tail(matchValue[1]);
                        }
                        else {
                            pattern_matching_result_1 = 2;
                        }
                    }
                    else {
                        pattern_matching_result_1 = 2;
                    }
                    switch (pattern_matching_result_1) {
                        case 0: {
                            start_1_mut = xs_1;
                            list_1_mut = ys_1;
                            continue loop_1;
                        }
                        case 1: {
                            return true;
                        }
                        case 2: {
                            return false;
                        }
                    }
                    break;
                }
            }), loop_1(bracket, _arg))) {
                return [reverse(acc), _arg];
            }
            else if (isEmpty(_arg)) {
                return void 0;
            }
            else {
                acc_mut = cons(head(_arg), acc);
                _arg_mut = tail(_arg);
                continue loop;
            }
            break;
        }
    };
    if ((loop_2 = ((start_1_1_mut, list_1_1_mut) => {
        loop_2:
        while (true) {
            const start_1_1 = start_1_1_mut, list_1_1 = list_1_1_mut;
            const matchValue_1 = [start_1_1, list_1_1];
            let pattern_matching_result_2, x_1_1, xs_1_1, y_1_1, ys_1_1;
            if (isEmpty(matchValue_1[0])) {
                pattern_matching_result_2 = 1;
            }
            else if (!isEmpty(matchValue_1[1])) {
                if (head(matchValue_1[0]) === head(matchValue_1[1])) {
                    pattern_matching_result_2 = 0;
                    x_1_1 = head(matchValue_1[0]);
                    xs_1_1 = tail(matchValue_1[0]);
                    y_1_1 = head(matchValue_1[1]);
                    ys_1_1 = tail(matchValue_1[1]);
                }
                else {
                    pattern_matching_result_2 = 2;
                }
            }
            else {
                pattern_matching_result_2 = 2;
            }
            switch (pattern_matching_result_2) {
                case 0: {
                    start_1_1_mut = xs_1_1;
                    list_1_1_mut = ys_1_1;
                    continue loop_2;
                }
                case 1: {
                    return true;
                }
                case 2: {
                    return false;
                }
            }
            break;
        }
    }), loop_2(bracket, input))) {
        const matchValue_2 = loop(empty(), skip(length(bracket), input));
        if (matchValue_2 == null) {
            return void 0;
        }
        else {
            const post = matchValue_2[1];
            return [matchValue_2[0], skip(length(bracket), post)];
        }
    }
    else {
        return void 0;
    }
}

export function $007CDelimitedLatexDisplayMath$007C_$007C(bracket, input) {
    let loop_2;
    const loop = (acc_mut, _arg_mut) => {
        let loop_1;
        loop:
        while (true) {
            const acc = acc_mut, _arg = _arg_mut;
            let activePatternResult;
            const input_1 = _arg;
            let pattern_matching_result, c, rest;
            if (!isEmpty(input_1)) {
                if (head(input_1) === "\\") {
                    if (!isEmpty(tail(input_1))) {
                        if (head(tail(input_1)) === "$") {
                            pattern_matching_result = 0;
                            c = head(tail(input_1));
                            rest = tail(tail(input_1));
                        }
                        else {
                            pattern_matching_result = 1;
                        }
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
            switch (pattern_matching_result) {
                case 0: {
                    activePatternResult = [c, rest];
                    break;
                }
                case 1: {
                    activePatternResult = (void 0);
                    break;
                }
            }
            if (activePatternResult != null) {
                const x_2 = activePatternResult[0];
                const xs_2 = activePatternResult[1];
                acc_mut = ofArrayWithTail([x_2, "\\"], acc);
                _arg_mut = xs_2;
                continue loop;
            }
            else if ((loop_1 = ((start_1_mut, list_1_mut) => {
                loop_1:
                while (true) {
                    const start_1 = start_1_mut, list_1 = list_1_mut;
                    const matchValue = [start_1, list_1];
                    let pattern_matching_result_1, x_1, xs_1, y_1, ys_1;
                    if (isEmpty(matchValue[0])) {
                        pattern_matching_result_1 = 1;
                    }
                    else if (!isEmpty(matchValue[1])) {
                        if (head(matchValue[0]) === head(matchValue[1])) {
                            pattern_matching_result_1 = 0;
                            x_1 = head(matchValue[0]);
                            xs_1 = tail(matchValue[0]);
                            y_1 = head(matchValue[1]);
                            ys_1 = tail(matchValue[1]);
                        }
                        else {
                            pattern_matching_result_1 = 2;
                        }
                    }
                    else {
                        pattern_matching_result_1 = 2;
                    }
                    switch (pattern_matching_result_1) {
                        case 0: {
                            start_1_mut = xs_1;
                            list_1_mut = ys_1;
                            continue loop_1;
                        }
                        case 1: {
                            return true;
                        }
                        case 2: {
                            return false;
                        }
                    }
                    break;
                }
            }), loop_1(bracket, _arg))) {
                return [reverse(acc), _arg];
            }
            else if (isEmpty(_arg)) {
                return void 0;
            }
            else {
                acc_mut = cons(head(_arg), acc);
                _arg_mut = tail(_arg);
                continue loop;
            }
            break;
        }
    };
    if ((loop_2 = ((start_1_1_mut, list_1_1_mut) => {
        loop_2:
        while (true) {
            const start_1_1 = start_1_1_mut, list_1_1 = list_1_1_mut;
            const matchValue_1 = [start_1_1, list_1_1];
            let pattern_matching_result_2, x_1_1, xs_1_1, y_1_1, ys_1_1;
            if (isEmpty(matchValue_1[0])) {
                pattern_matching_result_2 = 1;
            }
            else if (!isEmpty(matchValue_1[1])) {
                if (head(matchValue_1[0]) === head(matchValue_1[1])) {
                    pattern_matching_result_2 = 0;
                    x_1_1 = head(matchValue_1[0]);
                    xs_1_1 = tail(matchValue_1[0]);
                    y_1_1 = head(matchValue_1[1]);
                    ys_1_1 = tail(matchValue_1[1]);
                }
                else {
                    pattern_matching_result_2 = 2;
                }
            }
            else {
                pattern_matching_result_2 = 2;
            }
            switch (pattern_matching_result_2) {
                case 0: {
                    start_1_1_mut = xs_1_1;
                    list_1_1_mut = ys_1_1;
                    continue loop_2;
                }
                case 1: {
                    return true;
                }
                case 2: {
                    return false;
                }
            }
            break;
        }
    }), loop_2(bracket, input))) {
        const matchValue_2 = loop(empty(), skip(length(bracket), input));
        if (matchValue_2 == null) {
            return void 0;
        }
        else {
            const post = matchValue_2[1];
            return [matchValue_2[0], skip(length(bracket), post)];
        }
    }
    else {
        return void 0;
    }
}

export function $007CDelimitedLatexInlineMath$007C_$007C(bracket, input) {
    let loop_2;
    const loop = (acc_mut, _arg_mut) => {
        let loop_1;
        loop:
        while (true) {
            const acc = acc_mut, _arg = _arg_mut;
            let activePatternResult;
            const input_1 = _arg;
            let pattern_matching_result, c, rest;
            if (!isEmpty(input_1)) {
                if (head(input_1) === "\\") {
                    if (!isEmpty(tail(input_1))) {
                        if (head(tail(input_1)) === "$") {
                            pattern_matching_result = 0;
                            c = head(tail(input_1));
                            rest = tail(tail(input_1));
                        }
                        else {
                            pattern_matching_result = 1;
                        }
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
            switch (pattern_matching_result) {
                case 0: {
                    activePatternResult = [c, rest];
                    break;
                }
                case 1: {
                    activePatternResult = (void 0);
                    break;
                }
            }
            if (activePatternResult != null) {
                const x_2 = activePatternResult[0];
                const xs_2 = activePatternResult[1];
                acc_mut = ofArrayWithTail([x_2, "\\"], acc);
                _arg_mut = xs_2;
                continue loop;
            }
            else if ((loop_1 = ((start_1_mut, list_1_mut) => {
                loop_1:
                while (true) {
                    const start_1 = start_1_mut, list_1 = list_1_mut;
                    const matchValue = [start_1, list_1];
                    let pattern_matching_result_1, x_1, xs_1, y_1, ys_1;
                    if (isEmpty(matchValue[0])) {
                        pattern_matching_result_1 = 1;
                    }
                    else if (!isEmpty(matchValue[1])) {
                        if (head(matchValue[0]) === head(matchValue[1])) {
                            pattern_matching_result_1 = 0;
                            x_1 = head(matchValue[0]);
                            xs_1 = tail(matchValue[0]);
                            y_1 = head(matchValue[1]);
                            ys_1 = tail(matchValue[1]);
                        }
                        else {
                            pattern_matching_result_1 = 2;
                        }
                    }
                    else {
                        pattern_matching_result_1 = 2;
                    }
                    switch (pattern_matching_result_1) {
                        case 0: {
                            start_1_mut = xs_1;
                            list_1_mut = ys_1;
                            continue loop_1;
                        }
                        case 1: {
                            return true;
                        }
                        case 2: {
                            return false;
                        }
                    }
                    break;
                }
            }), loop_1(bracket, _arg))) {
                return [reverse(acc), _arg];
            }
            else if (isEmpty(_arg)) {
                return void 0;
            }
            else {
                acc_mut = cons(head(_arg), acc);
                _arg_mut = tail(_arg);
                continue loop;
            }
            break;
        }
    };
    if ((loop_2 = ((start_1_1_mut, list_1_1_mut) => {
        loop_2:
        while (true) {
            const start_1_1 = start_1_1_mut, list_1_1 = list_1_1_mut;
            const matchValue_1 = [start_1_1, list_1_1];
            let pattern_matching_result_2, x_1_1, xs_1_1, y_1_1, ys_1_1;
            if (isEmpty(matchValue_1[0])) {
                pattern_matching_result_2 = 1;
            }
            else if (!isEmpty(matchValue_1[1])) {
                if (head(matchValue_1[0]) === head(matchValue_1[1])) {
                    pattern_matching_result_2 = 0;
                    x_1_1 = head(matchValue_1[0]);
                    xs_1_1 = tail(matchValue_1[0]);
                    y_1_1 = head(matchValue_1[1]);
                    ys_1_1 = tail(matchValue_1[1]);
                }
                else {
                    pattern_matching_result_2 = 2;
                }
            }
            else {
                pattern_matching_result_2 = 2;
            }
            switch (pattern_matching_result_2) {
                case 0: {
                    start_1_1_mut = xs_1_1;
                    list_1_1_mut = ys_1_1;
                    continue loop_2;
                }
                case 1: {
                    return true;
                }
                case 2: {
                    return false;
                }
            }
            break;
        }
    }), loop_2(bracket, input))) {
        const matchValue_2 = loop(empty(), skip(length(bracket), input));
        if (matchValue_2 == null) {
            return void 0;
        }
        else {
            const post = matchValue_2[1];
            return [matchValue_2[0], skip(length(bracket), post)];
        }
    }
    else {
        return void 0;
    }
}

export function $007CIndirectLink$007C_$007C(_arg) {
    let pattern_matching_result, body, link, rest;
    const activePatternResult = List_$007CBracketDelimited$007C_$007C("[", "]", _arg);
    if (activePatternResult != null) {
        if (!isEmpty(activePatternResult[1])) {
            if (head(activePatternResult[1]) === "\r") {
                if (!isEmpty(tail(activePatternResult[1]))) {
                    if (head(tail(activePatternResult[1])) === "\n") {
                        const activePatternResult_1 = List_$007CBracketDelimited$007C_$007C("[", "]", tail(tail(activePatternResult[1])));
                        if (activePatternResult_1 != null) {
                            const activePatternResult_2 = List_$007CAsString$007C(activePatternResult_1[0]);
                            pattern_matching_result = 0;
                            body = activePatternResult[0];
                            link = activePatternResult_2;
                            rest = activePatternResult_1[1];
                        }
                        else {
                            pattern_matching_result = 1;
                        }
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return [body, link, ("\r\n[" + link) + "]", rest];
        }
        case 1: {
            let pattern_matching_result_1, body_1, c, link_1, rest_1;
            const activePatternResult_3 = List_$007CBracketDelimited$007C_$007C("[", "]", _arg);
            if (activePatternResult_3 != null) {
                if (!isEmpty(activePatternResult_3[1])) {
                    if (head(activePatternResult_3[1]) === "\n") {
                        const activePatternResult_4 = List_$007CBracketDelimited$007C_$007C("[", "]", tail(activePatternResult_3[1]));
                        if (activePatternResult_4 != null) {
                            const activePatternResult_5 = List_$007CAsString$007C(activePatternResult_4[0]);
                            pattern_matching_result_1 = 0;
                            body_1 = activePatternResult_3[0];
                            c = head(activePatternResult_3[1]);
                            link_1 = activePatternResult_5;
                            rest_1 = activePatternResult_4[1];
                        }
                        else {
                            pattern_matching_result_1 = 1;
                        }
                    }
                    else if (head(activePatternResult_3[1]) === " ") {
                        const activePatternResult_6 = List_$007CBracketDelimited$007C_$007C("[", "]", tail(activePatternResult_3[1]));
                        if (activePatternResult_6 != null) {
                            const activePatternResult_7 = List_$007CAsString$007C(activePatternResult_6[0]);
                            pattern_matching_result_1 = 0;
                            body_1 = activePatternResult_3[0];
                            c = head(activePatternResult_3[1]);
                            link_1 = activePatternResult_7;
                            rest_1 = activePatternResult_6[1];
                        }
                        else {
                            pattern_matching_result_1 = 1;
                        }
                    }
                    else {
                        pattern_matching_result_1 = 1;
                    }
                }
                else {
                    pattern_matching_result_1 = 1;
                }
            }
            else {
                pattern_matching_result_1 = 1;
            }
            switch (pattern_matching_result_1) {
                case 0: {
                    return [body_1, link_1, ((c + "[") + link_1) + "]", rest_1];
                }
                case 1: {
                    let pattern_matching_result_2, body_2, link_2, rest_2;
                    const activePatternResult_8 = List_$007CBracketDelimited$007C_$007C("[", "]", _arg);
                    if (activePatternResult_8 != null) {
                        const activePatternResult_9 = List_$007CBracketDelimited$007C_$007C("[", "]", activePatternResult_8[1]);
                        if (activePatternResult_9 != null) {
                            const activePatternResult_10 = List_$007CAsString$007C(activePatternResult_9[0]);
                            pattern_matching_result_2 = 0;
                            body_2 = activePatternResult_8[0];
                            link_2 = activePatternResult_10;
                            rest_2 = activePatternResult_9[1];
                        }
                        else {
                            pattern_matching_result_2 = 1;
                        }
                    }
                    else {
                        pattern_matching_result_2 = 1;
                    }
                    switch (pattern_matching_result_2) {
                        case 0: {
                            return [body_2, link_2, ("[" + link_2) + "]", rest_2];
                        }
                        case 1: {
                            const activePatternResult_11 = List_$007CBracketDelimited$007C_$007C("[", "]", _arg);
                            if (activePatternResult_11 != null) {
                                const body_3 = activePatternResult_11[0];
                                const rest_3 = activePatternResult_11[1];
                                return [body_3, "", "", rest_3];
                            }
                            else {
                                return void 0;
                            }
                        }
                    }
                }
            }
        }
    }
}

export function $007CDirectLink$007C_$007C(_arg) {
    let pattern_matching_result, body, link, rest;
    const activePatternResult = List_$007CBracketDelimited$007C_$007C("[", "]", _arg);
    if (activePatternResult != null) {
        const activePatternResult_1 = List_$007CBracketDelimited$007C_$007C("(", ")", activePatternResult[1]);
        if (activePatternResult_1 != null) {
            pattern_matching_result = 0;
            body = activePatternResult[0];
            link = activePatternResult_1[0];
            rest = activePatternResult_1[1];
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return [body, link, rest];
        }
        case 1: {
            return void 0;
        }
    }
}

export function $007CAutoLink$007C_$007C(input) {
    return tryPick((scheme) => {
        let loop, loop_1;
        const prefix = ofArray(scheme.split(""));
        let activePatternResult;
        const startl = prefix;
        const endl = singleton(" ");
        const input_1 = input;
        if ((loop = ((start_1_mut, list_1_mut) => {
            loop:
            while (true) {
                const start_1 = start_1_mut, list_1 = list_1_mut;
                const matchValue = [start_1, list_1];
                let pattern_matching_result, x_1, xs_1, y_1, ys_1;
                if (isEmpty(matchValue[0])) {
                    pattern_matching_result = 1;
                }
                else if (!isEmpty(matchValue[1])) {
                    if (head(matchValue[0]) === head(matchValue[1])) {
                        pattern_matching_result = 0;
                        x_1 = head(matchValue[0]);
                        xs_1 = tail(matchValue[0]);
                        y_1 = head(matchValue[1]);
                        ys_1 = tail(matchValue[1]);
                    }
                    else {
                        pattern_matching_result = 2;
                    }
                }
                else {
                    pattern_matching_result = 2;
                }
                switch (pattern_matching_result) {
                    case 0: {
                        start_1_mut = xs_1;
                        list_1_mut = ys_1;
                        continue loop;
                    }
                    case 1: {
                        return true;
                    }
                    case 2: {
                        return false;
                    }
                }
                break;
            }
        }), loop(startl, input_1))) {
            const matchValue_1 = List_partitionUntilEquals(endl, skip(length(startl), input_1));
            if (matchValue_1 == null) {
                activePatternResult = (void 0);
            }
            else {
                const post = matchValue_1[1];
                activePatternResult = [matchValue_1[0], skip(length(endl), post), length(startl), length(endl)];
            }
        }
        else {
            activePatternResult = (void 0);
        }
        if (activePatternResult != null) {
            const activePatternResult_1 = List_$007CAsString$007C(activePatternResult[0]);
            const _e = activePatternResult[3] | 0;
            const _s = activePatternResult[2] | 0;
            const rest = activePatternResult[1];
            return [scheme + activePatternResult_1, cons(" ", rest)];
        }
        else {
            let activePatternResult_2;
            const input_2 = input;
            activePatternResult_2 = (((loop_1 = ((start_1_1_mut, list_1_1_mut) => {
                loop_1:
                while (true) {
                    const start_1_1 = start_1_1_mut, list_1_1 = list_1_1_mut;
                    const matchValue_2 = [start_1_1, list_1_1];
                    let pattern_matching_result_1, x_1_1, xs_1_1, y_1_1, ys_1_1;
                    if (isEmpty(matchValue_2[0])) {
                        pattern_matching_result_1 = 1;
                    }
                    else if (!isEmpty(matchValue_2[1])) {
                        if (head(matchValue_2[0]) === head(matchValue_2[1])) {
                            pattern_matching_result_1 = 0;
                            x_1_1 = head(matchValue_2[0]);
                            xs_1_1 = tail(matchValue_2[0]);
                            y_1_1 = head(matchValue_2[1]);
                            ys_1_1 = tail(matchValue_2[1]);
                        }
                        else {
                            pattern_matching_result_1 = 2;
                        }
                    }
                    else {
                        pattern_matching_result_1 = 2;
                    }
                    switch (pattern_matching_result_1) {
                        case 0: {
                            start_1_1_mut = xs_1_1;
                            list_1_1_mut = ys_1_1;
                            continue loop_1;
                        }
                        case 1: {
                            return true;
                        }
                        case 2: {
                            return false;
                        }
                    }
                    break;
                }
            }), loop_1(prefix, input_2))) ? input_2 : (void 0));
            if (activePatternResult_2 != null) {
                const activePatternResult_3 = List_$007CAsString$007C(activePatternResult_2);
                return [activePatternResult_3, empty()];
            }
            else {
                return void 0;
            }
        }
    }, ["http://", "https://"]);
}

export function $007CEmphasised$007C_$007C(_arg) {
    let pattern_matching_result, _tail, input;
    if (!isEmpty(_arg)) {
        if (head(_arg) === "*") {
            pattern_matching_result = 0;
            _tail = tail(_arg);
            input = _arg;
        }
        else if (head(_arg) === "_") {
            pattern_matching_result = 0;
            _tail = tail(_arg);
            input = _arg;
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            let pattern_matching_result_1, body, rest;
            const activePatternResult = $007CDelimitedMarkdown$007C_$007C(ofArray(["_", "_", "_"]), input);
            if (activePatternResult != null) {
                pattern_matching_result_1 = 0;
                body = activePatternResult[0];
                rest = activePatternResult[1];
            }
            else {
                const activePatternResult_1 = $007CDelimitedMarkdown$007C_$007C(ofArray(["*", "*", "*"]), input);
                if (activePatternResult_1 != null) {
                    pattern_matching_result_1 = 0;
                    body = activePatternResult_1[0];
                    rest = activePatternResult_1[1];
                }
                else {
                    pattern_matching_result_1 = 1;
                }
            }
            switch (pattern_matching_result_1) {
                case 0: {
                    return [body, (arg_3) => {
                        let tupledArg;
                        return new MarkdownSpan(2, singleton((tupledArg = arg_3, new MarkdownSpan(3, tupledArg[0], tupledArg[1]))), void 0);
                    }, rest];
                }
                case 1: {
                    let pattern_matching_result_2, body_1, rest_1;
                    const activePatternResult_2 = $007CDelimitedMarkdown$007C_$007C(ofArray(["_", "_"]), input);
                    if (activePatternResult_2 != null) {
                        pattern_matching_result_2 = 0;
                        body_1 = activePatternResult_2[0];
                        rest_1 = activePatternResult_2[1];
                    }
                    else {
                        const activePatternResult_3 = $007CDelimitedMarkdown$007C_$007C(ofArray(["*", "*"]), input);
                        if (activePatternResult_3 != null) {
                            pattern_matching_result_2 = 0;
                            body_1 = activePatternResult_3[0];
                            rest_1 = activePatternResult_3[1];
                        }
                        else {
                            pattern_matching_result_2 = 1;
                        }
                    }
                    switch (pattern_matching_result_2) {
                        case 0: {
                            return [body_1, (tupledArg_1) => (new MarkdownSpan(2, tupledArg_1[0], tupledArg_1[1])), rest_1];
                        }
                        case 1: {
                            let pattern_matching_result_3, body_2, rest_2;
                            const activePatternResult_4 = $007CDelimitedMarkdown$007C_$007C(singleton("_"), input);
                            if (activePatternResult_4 != null) {
                                pattern_matching_result_3 = 0;
                                body_2 = activePatternResult_4[0];
                                rest_2 = activePatternResult_4[1];
                            }
                            else {
                                const activePatternResult_5 = $007CDelimitedMarkdown$007C_$007C(singleton("*"), input);
                                if (activePatternResult_5 != null) {
                                    pattern_matching_result_3 = 0;
                                    body_2 = activePatternResult_5[0];
                                    rest_2 = activePatternResult_5[1];
                                }
                                else {
                                    pattern_matching_result_3 = 1;
                                }
                            }
                            switch (pattern_matching_result_3) {
                                case 0: {
                                    return [body_2, (tupledArg_2) => (new MarkdownSpan(3, tupledArg_2[0], tupledArg_2[1])), rest_2];
                                }
                                case 1: {
                                    return void 0;
                                }
                            }
                        }
                    }
                }
            }
        }
        case 1: {
            return void 0;
        }
    }
}

export function $007CHtmlEntity$007C_$007C(input) {
    let arg;
    let pattern_matching_result;
    if (!isEmpty(input)) {
        if (head(input) === "\u0026") {
            pattern_matching_result = 0;
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            const match$0027 = match(create("^\u0026(?:#x[a-f0-9]{1,8}|#[0-9]{1,8}|[a-z][a-z0-9]{1,31});"), (arg = toArray(input), arg.join('')));
            if (match$0027 != null) {
                const entity = match$0027[0];
                return [entity, splitAt(entity.length, input)[1]];
            }
            else {
                return void 0;
            }
        }
        case 1: {
            return void 0;
        }
    }
}

export class ParsingContext extends Record {
    constructor(Links, Newline, IsFirst, CurrentRange, ParseOptions) {
        super();
        this.Links = Links;
        this.Newline = Newline;
        this.IsFirst = IsFirst;
        this.CurrentRange = CurrentRange;
        this.ParseOptions = (ParseOptions | 0);
    }
}

export function ParsingContext$reflection() {
    return record_type("Fable.Formatting.Markdown.Parser.ParsingContext", [], ParsingContext, () => [["Links", class_type("System.Collections.Generic.Dictionary`2", [string_type, tuple_type(string_type, option_type(string_type))])], ["Newline", string_type], ["IsFirst", bool_type], ["CurrentRange", option_type(MarkdownRange$reflection())], ["ParseOptions", enum_type("Fable.Formatting.Markdown.MarkdownParseOptions", int32_type, [["None", 0], ["ParseCodeAsOther", 1], ["ParseNonCodeAsOther", 2], ["AllowYamlFrontMatter", 4]])]]);
}

export function ParsingContext__get_ParseCodeAsOther(x) {
    return (x.ParseOptions & 1) !== 0;
}

export function ParsingContext__get_ParseNonCodeAsOther(x) {
    return (x.ParseOptions & 2) !== 0;
}

export function ParsingContext__get_AllowYamlFrontMatter(x) {
    return (x.ParseOptions & 4) !== 0;
}

export function parseChars(acc, input, ctx) {
    return delay(() => {
        let matchValue_30, n_3, inputRecord_3, StartColumn_2, loop_13, loop_12, rest_11, link, _s, _e, loop, str_1, loop_2, str_3, loop_4, str_5, loop_6, str_7, loop_8, str_9, loop_10, str_11;
        const accLiterals = new Lazy(() => {
            let inputRecord, EndColumn, matchValue_1, n_1, inputRecord_1, StartColumn;
            if (isEmpty(acc)) {
                return [empty(), ctx];
            }
            else {
                let range;
                const matchValue = ctx.CurrentRange;
                if (matchValue == null) {
                    range = (void 0);
                }
                else {
                    const n = matchValue;
                    range = ((inputRecord = (new FSharpRef(n)), (EndColumn = ((n.StartColumn + length(acc)) | 0), new MarkdownRange(inputRecord.contents.StartLine, inputRecord.contents.StartColumn, inputRecord.contents.EndLine, EndColumn))));
                }
                const ctx_1 = new ParsingContext(ctx.Links, ctx.Newline, ctx.IsFirst, (matchValue_1 = ctx.CurrentRange, (matchValue_1 == null) ? (void 0) : ((n_1 = matchValue_1, (inputRecord_1 = (new FSharpRef(n_1)), (StartColumn = ((n_1.StartColumn + length(acc)) | 0), new MarkdownRange(inputRecord_1.contents.StartLine, StartColumn, inputRecord_1.contents.EndLine, inputRecord_1.contents.EndColumn)))))), ctx.ParseOptions);
                return [singleton(new MarkdownSpan(0, toArray(reverse(acc)).join(''), range)), ctx_1];
            }
        });
        const matchValue_2 = input;
        let pattern_matching_result, rest_6, entity, rest_7, rest_8, c_6, rest_9, body, e, rest_10, s;
        if (!isEmpty(matchValue_2)) {
            if (head(matchValue_2) === " ") {
                if (!isEmpty(tail(matchValue_2))) {
                    if (head(tail(matchValue_2)) === " ") {
                        if (!isEmpty(tail(tail(matchValue_2)))) {
                            if (head(tail(tail(matchValue_2))) === "\n") {
                                pattern_matching_result = 0;
                                rest_6 = tail(tail(tail(matchValue_2)));
                            }
                            else if (head(tail(tail(matchValue_2))) === "\r") {
                                if (!isEmpty(tail(tail(tail(matchValue_2))))) {
                                    if (head(tail(tail(tail(matchValue_2)))) === "\n") {
                                        pattern_matching_result = 0;
                                        rest_6 = tail(tail(tail(tail(matchValue_2))));
                                    }
                                    else {
                                        pattern_matching_result = 0;
                                        rest_6 = tail(tail(tail(matchValue_2)));
                                    }
                                }
                                else {
                                    pattern_matching_result = 0;
                                    rest_6 = tail(tail(tail(matchValue_2)));
                                }
                            }
                            else {
                                const activePatternResult = $007CHtmlEntity$007C_$007C(matchValue_2);
                                if (activePatternResult != null) {
                                    pattern_matching_result = 1;
                                    entity = activePatternResult[0];
                                    rest_7 = activePatternResult[1];
                                }
                                else {
                                    let activePatternResult_1;
                                    const input_1 = matchValue_2;
                                    let pattern_matching_result_5, c, rest;
                                    if (!isEmpty(input_1)) {
                                        if (head(input_1) === "\\") {
                                            if (!isEmpty(tail(input_1))) {
                                                if (head(tail(input_1)) === "!") {
                                                    pattern_matching_result_5 = 0;
                                                    c = head(tail(input_1));
                                                    rest = tail(tail(input_1));
                                                }
                                                else if (head(tail(input_1)) === "#") {
                                                    pattern_matching_result_5 = 0;
                                                    c = head(tail(input_1));
                                                    rest = tail(tail(input_1));
                                                }
                                                else if (head(tail(input_1)) === "$") {
                                                    pattern_matching_result_5 = 0;
                                                    c = head(tail(input_1));
                                                    rest = tail(tail(input_1));
                                                }
                                                else if (head(tail(input_1)) === "(") {
                                                    pattern_matching_result_5 = 0;
                                                    c = head(tail(input_1));
                                                    rest = tail(tail(input_1));
                                                }
                                                else if (head(tail(input_1)) === ")") {
                                                    pattern_matching_result_5 = 0;
                                                    c = head(tail(input_1));
                                                    rest = tail(tail(input_1));
                                                }
                                                else if (head(tail(input_1)) === "*") {
                                                    pattern_matching_result_5 = 0;
                                                    c = head(tail(input_1));
                                                    rest = tail(tail(input_1));
                                                }
                                                else if (head(tail(input_1)) === "+") {
                                                    pattern_matching_result_5 = 0;
                                                    c = head(tail(input_1));
                                                    rest = tail(tail(input_1));
                                                }
                                                else if (head(tail(input_1)) === "-") {
                                                    pattern_matching_result_5 = 0;
                                                    c = head(tail(input_1));
                                                    rest = tail(tail(input_1));
                                                }
                                                else if (head(tail(input_1)) === ".") {
                                                    pattern_matching_result_5 = 0;
                                                    c = head(tail(input_1));
                                                    rest = tail(tail(input_1));
                                                }
                                                else if (head(tail(input_1)) === "\u003e") {
                                                    pattern_matching_result_5 = 0;
                                                    c = head(tail(input_1));
                                                    rest = tail(tail(input_1));
                                                }
                                                else if (head(tail(input_1)) === "[") {
                                                    pattern_matching_result_5 = 0;
                                                    c = head(tail(input_1));
                                                    rest = tail(tail(input_1));
                                                }
                                                else if (head(tail(input_1)) === "\\") {
                                                    pattern_matching_result_5 = 0;
                                                    c = head(tail(input_1));
                                                    rest = tail(tail(input_1));
                                                }
                                                else if (head(tail(input_1)) === "]") {
                                                    pattern_matching_result_5 = 0;
                                                    c = head(tail(input_1));
                                                    rest = tail(tail(input_1));
                                                }
                                                else if (head(tail(input_1)) === "_") {
                                                    pattern_matching_result_5 = 0;
                                                    c = head(tail(input_1));
                                                    rest = tail(tail(input_1));
                                                }
                                                else if (head(tail(input_1)) === "`") {
                                                    pattern_matching_result_5 = 0;
                                                    c = head(tail(input_1));
                                                    rest = tail(tail(input_1));
                                                }
                                                else if (head(tail(input_1)) === "{") {
                                                    pattern_matching_result_5 = 0;
                                                    c = head(tail(input_1));
                                                    rest = tail(tail(input_1));
                                                }
                                                else if (head(tail(input_1)) === "}") {
                                                    pattern_matching_result_5 = 0;
                                                    c = head(tail(input_1));
                                                    rest = tail(tail(input_1));
                                                }
                                                else {
                                                    pattern_matching_result_5 = 1;
                                                }
                                            }
                                            else {
                                                pattern_matching_result_5 = 1;
                                            }
                                        }
                                        else {
                                            pattern_matching_result_5 = 1;
                                        }
                                    }
                                    else {
                                        pattern_matching_result_5 = 1;
                                    }
                                    switch (pattern_matching_result_5) {
                                        case 0: {
                                            activePatternResult_1 = [c, rest];
                                            break;
                                        }
                                        case 1: {
                                            activePatternResult_1 = (void 0);
                                            break;
                                        }
                                    }
                                    if (activePatternResult_1 != null) {
                                        pattern_matching_result = 3;
                                        c_6 = activePatternResult_1[0];
                                        rest_9 = activePatternResult_1[1];
                                    }
                                    else {
                                        let activePatternResult_2;
                                        const startl = ofArray(["`", " "]);
                                        const endl = ofArray([" ", "`"]);
                                        const input_2 = matchValue_2;
                                        if ((loop = ((start_1_mut, list_1_1_mut) => {
                                            loop:
                                            while (true) {
                                                const start_1 = start_1_mut, list_1_1 = list_1_1_mut;
                                                const matchValue_3 = [start_1, list_1_1];
                                                let pattern_matching_result_6, x_1, xs_1, y_1, ys_1;
                                                if (isEmpty(matchValue_3[0])) {
                                                    pattern_matching_result_6 = 1;
                                                }
                                                else if (!isEmpty(matchValue_3[1])) {
                                                    if (head(matchValue_3[0]) === head(matchValue_3[1])) {
                                                        pattern_matching_result_6 = 0;
                                                        x_1 = head(matchValue_3[0]);
                                                        xs_1 = tail(matchValue_3[0]);
                                                        y_1 = head(matchValue_3[1]);
                                                        ys_1 = tail(matchValue_3[1]);
                                                    }
                                                    else {
                                                        pattern_matching_result_6 = 2;
                                                    }
                                                }
                                                else {
                                                    pattern_matching_result_6 = 2;
                                                }
                                                switch (pattern_matching_result_6) {
                                                    case 0: {
                                                        start_1_mut = xs_1;
                                                        list_1_1_mut = ys_1;
                                                        continue loop;
                                                    }
                                                    case 1: {
                                                        return true;
                                                    }
                                                    case 2: {
                                                        return false;
                                                    }
                                                }
                                                break;
                                            }
                                        }), loop(startl, input_2))) {
                                            const matchValue_4 = List_partitionUntilEquals(endl, skip(length(startl), input_2));
                                            if (matchValue_4 == null) {
                                                activePatternResult_2 = (void 0);
                                            }
                                            else {
                                                const post = matchValue_4[1];
                                                activePatternResult_2 = [matchValue_4[0], skip(length(endl), post), length(startl), length(endl)];
                                            }
                                        }
                                        else {
                                            activePatternResult_2 = (void 0);
                                        }
                                        if (activePatternResult_2 != null) {
                                            pattern_matching_result = 4;
                                            body = activePatternResult_2[0];
                                            e = activePatternResult_2[3];
                                            rest_10 = activePatternResult_2[1];
                                            s = activePatternResult_2[2];
                                        }
                                        else {
                                            let activePatternResult_3;
                                            const str = "`";
                                            const input_3 = matchValue_2;
                                            const strs = List_partitionWhile((i) => (i === str), input_3)[0];
                                            activePatternResult_3 = ((!isEmpty(strs)) ? ((str_1 = initialize(length(strs), (_arg) => str), (input_4) => {
                                                let loop_1;
                                                const startl_1 = str_1;
                                                const endl_1 = str_1;
                                                const input_5 = input_4;
                                                if ((loop_1 = ((start_1_1_mut, list_1_2_mut) => {
                                                    loop_1:
                                                    while (true) {
                                                        const start_1_1 = start_1_1_mut, list_1_2 = list_1_2_mut;
                                                        const matchValue_5 = [start_1_1, list_1_2];
                                                        let pattern_matching_result_7, x_1_1, xs_1_1, y_1_1, ys_1_1;
                                                        if (isEmpty(matchValue_5[0])) {
                                                            pattern_matching_result_7 = 1;
                                                        }
                                                        else if (!isEmpty(matchValue_5[1])) {
                                                            if (head(matchValue_5[0]) === head(matchValue_5[1])) {
                                                                pattern_matching_result_7 = 0;
                                                                x_1_1 = head(matchValue_5[0]);
                                                                xs_1_1 = tail(matchValue_5[0]);
                                                                y_1_1 = head(matchValue_5[1]);
                                                                ys_1_1 = tail(matchValue_5[1]);
                                                            }
                                                            else {
                                                                pattern_matching_result_7 = 2;
                                                            }
                                                        }
                                                        else {
                                                            pattern_matching_result_7 = 2;
                                                        }
                                                        switch (pattern_matching_result_7) {
                                                            case 0: {
                                                                start_1_1_mut = xs_1_1;
                                                                list_1_2_mut = ys_1_1;
                                                                continue loop_1;
                                                            }
                                                            case 1: {
                                                                return true;
                                                            }
                                                            case 2: {
                                                                return false;
                                                            }
                                                        }
                                                        break;
                                                    }
                                                }), loop_1(startl_1, input_5))) {
                                                    const matchValue_6 = List_partitionUntilEquals(endl_1, skip(length(startl_1), input_5));
                                                    if (matchValue_6 == null) {
                                                        return void 0;
                                                    }
                                                    else {
                                                        const post_1 = matchValue_6[1];
                                                        return [matchValue_6[0], skip(length(endl_1), post_1), length(startl_1), length(endl_1)];
                                                    }
                                                }
                                                else {
                                                    return void 0;
                                                }
                                            }))(input_3) : (void 0));
                                            if (activePatternResult_3 != null) {
                                                pattern_matching_result = 4;
                                                body = activePatternResult_3[0];
                                                e = activePatternResult_3[3];
                                                rest_10 = activePatternResult_3[1];
                                                s = activePatternResult_3[2];
                                            }
                                            else {
                                                pattern_matching_result = 5;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            const activePatternResult_4 = $007CHtmlEntity$007C_$007C(matchValue_2);
                            if (activePatternResult_4 != null) {
                                pattern_matching_result = 1;
                                entity = activePatternResult_4[0];
                                rest_7 = activePatternResult_4[1];
                            }
                            else {
                                let activePatternResult_5;
                                const input_6 = matchValue_2;
                                let pattern_matching_result_8, c_1, rest_1;
                                if (!isEmpty(input_6)) {
                                    if (head(input_6) === "\\") {
                                        if (!isEmpty(tail(input_6))) {
                                            if (head(tail(input_6)) === "!") {
                                                pattern_matching_result_8 = 0;
                                                c_1 = head(tail(input_6));
                                                rest_1 = tail(tail(input_6));
                                            }
                                            else if (head(tail(input_6)) === "#") {
                                                pattern_matching_result_8 = 0;
                                                c_1 = head(tail(input_6));
                                                rest_1 = tail(tail(input_6));
                                            }
                                            else if (head(tail(input_6)) === "$") {
                                                pattern_matching_result_8 = 0;
                                                c_1 = head(tail(input_6));
                                                rest_1 = tail(tail(input_6));
                                            }
                                            else if (head(tail(input_6)) === "(") {
                                                pattern_matching_result_8 = 0;
                                                c_1 = head(tail(input_6));
                                                rest_1 = tail(tail(input_6));
                                            }
                                            else if (head(tail(input_6)) === ")") {
                                                pattern_matching_result_8 = 0;
                                                c_1 = head(tail(input_6));
                                                rest_1 = tail(tail(input_6));
                                            }
                                            else if (head(tail(input_6)) === "*") {
                                                pattern_matching_result_8 = 0;
                                                c_1 = head(tail(input_6));
                                                rest_1 = tail(tail(input_6));
                                            }
                                            else if (head(tail(input_6)) === "+") {
                                                pattern_matching_result_8 = 0;
                                                c_1 = head(tail(input_6));
                                                rest_1 = tail(tail(input_6));
                                            }
                                            else if (head(tail(input_6)) === "-") {
                                                pattern_matching_result_8 = 0;
                                                c_1 = head(tail(input_6));
                                                rest_1 = tail(tail(input_6));
                                            }
                                            else if (head(tail(input_6)) === ".") {
                                                pattern_matching_result_8 = 0;
                                                c_1 = head(tail(input_6));
                                                rest_1 = tail(tail(input_6));
                                            }
                                            else if (head(tail(input_6)) === "\u003e") {
                                                pattern_matching_result_8 = 0;
                                                c_1 = head(tail(input_6));
                                                rest_1 = tail(tail(input_6));
                                            }
                                            else if (head(tail(input_6)) === "[") {
                                                pattern_matching_result_8 = 0;
                                                c_1 = head(tail(input_6));
                                                rest_1 = tail(tail(input_6));
                                            }
                                            else if (head(tail(input_6)) === "\\") {
                                                pattern_matching_result_8 = 0;
                                                c_1 = head(tail(input_6));
                                                rest_1 = tail(tail(input_6));
                                            }
                                            else if (head(tail(input_6)) === "]") {
                                                pattern_matching_result_8 = 0;
                                                c_1 = head(tail(input_6));
                                                rest_1 = tail(tail(input_6));
                                            }
                                            else if (head(tail(input_6)) === "_") {
                                                pattern_matching_result_8 = 0;
                                                c_1 = head(tail(input_6));
                                                rest_1 = tail(tail(input_6));
                                            }
                                            else if (head(tail(input_6)) === "`") {
                                                pattern_matching_result_8 = 0;
                                                c_1 = head(tail(input_6));
                                                rest_1 = tail(tail(input_6));
                                            }
                                            else if (head(tail(input_6)) === "{") {
                                                pattern_matching_result_8 = 0;
                                                c_1 = head(tail(input_6));
                                                rest_1 = tail(tail(input_6));
                                            }
                                            else if (head(tail(input_6)) === "}") {
                                                pattern_matching_result_8 = 0;
                                                c_1 = head(tail(input_6));
                                                rest_1 = tail(tail(input_6));
                                            }
                                            else {
                                                pattern_matching_result_8 = 1;
                                            }
                                        }
                                        else {
                                            pattern_matching_result_8 = 1;
                                        }
                                    }
                                    else {
                                        pattern_matching_result_8 = 1;
                                    }
                                }
                                else {
                                    pattern_matching_result_8 = 1;
                                }
                                switch (pattern_matching_result_8) {
                                    case 0: {
                                        activePatternResult_5 = [c_1, rest_1];
                                        break;
                                    }
                                    case 1: {
                                        activePatternResult_5 = (void 0);
                                        break;
                                    }
                                }
                                if (activePatternResult_5 != null) {
                                    pattern_matching_result = 3;
                                    c_6 = activePatternResult_5[0];
                                    rest_9 = activePatternResult_5[1];
                                }
                                else {
                                    let activePatternResult_6;
                                    const startl_2 = ofArray(["`", " "]);
                                    const endl_2 = ofArray([" ", "`"]);
                                    const input_7 = matchValue_2;
                                    if ((loop_2 = ((start_1_2_mut, list_1_3_mut) => {
                                        loop_2:
                                        while (true) {
                                            const start_1_2 = start_1_2_mut, list_1_3 = list_1_3_mut;
                                            const matchValue_7 = [start_1_2, list_1_3];
                                            let pattern_matching_result_9, x_1_2, xs_1_2, y_1_2, ys_1_2;
                                            if (isEmpty(matchValue_7[0])) {
                                                pattern_matching_result_9 = 1;
                                            }
                                            else if (!isEmpty(matchValue_7[1])) {
                                                if (head(matchValue_7[0]) === head(matchValue_7[1])) {
                                                    pattern_matching_result_9 = 0;
                                                    x_1_2 = head(matchValue_7[0]);
                                                    xs_1_2 = tail(matchValue_7[0]);
                                                    y_1_2 = head(matchValue_7[1]);
                                                    ys_1_2 = tail(matchValue_7[1]);
                                                }
                                                else {
                                                    pattern_matching_result_9 = 2;
                                                }
                                            }
                                            else {
                                                pattern_matching_result_9 = 2;
                                            }
                                            switch (pattern_matching_result_9) {
                                                case 0: {
                                                    start_1_2_mut = xs_1_2;
                                                    list_1_3_mut = ys_1_2;
                                                    continue loop_2;
                                                }
                                                case 1: {
                                                    return true;
                                                }
                                                case 2: {
                                                    return false;
                                                }
                                            }
                                            break;
                                        }
                                    }), loop_2(startl_2, input_7))) {
                                        const matchValue_8 = List_partitionUntilEquals(endl_2, skip(length(startl_2), input_7));
                                        if (matchValue_8 == null) {
                                            activePatternResult_6 = (void 0);
                                        }
                                        else {
                                            const post_2 = matchValue_8[1];
                                            activePatternResult_6 = [matchValue_8[0], skip(length(endl_2), post_2), length(startl_2), length(endl_2)];
                                        }
                                    }
                                    else {
                                        activePatternResult_6 = (void 0);
                                    }
                                    if (activePatternResult_6 != null) {
                                        pattern_matching_result = 4;
                                        body = activePatternResult_6[0];
                                        e = activePatternResult_6[3];
                                        rest_10 = activePatternResult_6[1];
                                        s = activePatternResult_6[2];
                                    }
                                    else {
                                        let activePatternResult_7;
                                        const str_2 = "`";
                                        const input_8 = matchValue_2;
                                        const strs_1 = List_partitionWhile((i_1) => (i_1 === str_2), input_8)[0];
                                        activePatternResult_7 = ((!isEmpty(strs_1)) ? ((str_3 = initialize(length(strs_1), (_arg_1) => str_2), (input_9) => {
                                            let loop_3;
                                            const startl_3 = str_3;
                                            const endl_3 = str_3;
                                            const input_10 = input_9;
                                            if ((loop_3 = ((start_1_3_mut, list_1_4_mut) => {
                                                loop_3:
                                                while (true) {
                                                    const start_1_3 = start_1_3_mut, list_1_4 = list_1_4_mut;
                                                    const matchValue_9 = [start_1_3, list_1_4];
                                                    let pattern_matching_result_10, x_1_3, xs_1_3, y_1_3, ys_1_3;
                                                    if (isEmpty(matchValue_9[0])) {
                                                        pattern_matching_result_10 = 1;
                                                    }
                                                    else if (!isEmpty(matchValue_9[1])) {
                                                        if (head(matchValue_9[0]) === head(matchValue_9[1])) {
                                                            pattern_matching_result_10 = 0;
                                                            x_1_3 = head(matchValue_9[0]);
                                                            xs_1_3 = tail(matchValue_9[0]);
                                                            y_1_3 = head(matchValue_9[1]);
                                                            ys_1_3 = tail(matchValue_9[1]);
                                                        }
                                                        else {
                                                            pattern_matching_result_10 = 2;
                                                        }
                                                    }
                                                    else {
                                                        pattern_matching_result_10 = 2;
                                                    }
                                                    switch (pattern_matching_result_10) {
                                                        case 0: {
                                                            start_1_3_mut = xs_1_3;
                                                            list_1_4_mut = ys_1_3;
                                                            continue loop_3;
                                                        }
                                                        case 1: {
                                                            return true;
                                                        }
                                                        case 2: {
                                                            return false;
                                                        }
                                                    }
                                                    break;
                                                }
                                            }), loop_3(startl_3, input_10))) {
                                                const matchValue_10 = List_partitionUntilEquals(endl_3, skip(length(startl_3), input_10));
                                                if (matchValue_10 == null) {
                                                    return void 0;
                                                }
                                                else {
                                                    const post_3 = matchValue_10[1];
                                                    return [matchValue_10[0], skip(length(endl_3), post_3), length(startl_3), length(endl_3)];
                                                }
                                            }
                                            else {
                                                return void 0;
                                            }
                                        }))(input_8) : (void 0));
                                        if (activePatternResult_7 != null) {
                                            pattern_matching_result = 4;
                                            body = activePatternResult_7[0];
                                            e = activePatternResult_7[3];
                                            rest_10 = activePatternResult_7[1];
                                            s = activePatternResult_7[2];
                                        }
                                        else {
                                            pattern_matching_result = 5;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    else {
                        const activePatternResult_8 = $007CHtmlEntity$007C_$007C(matchValue_2);
                        if (activePatternResult_8 != null) {
                            pattern_matching_result = 1;
                            entity = activePatternResult_8[0];
                            rest_7 = activePatternResult_8[1];
                        }
                        else {
                            let activePatternResult_9;
                            const input_11 = matchValue_2;
                            let pattern_matching_result_11, c_2, rest_2;
                            if (!isEmpty(input_11)) {
                                if (head(input_11) === "\\") {
                                    if (!isEmpty(tail(input_11))) {
                                        if (head(tail(input_11)) === "!") {
                                            pattern_matching_result_11 = 0;
                                            c_2 = head(tail(input_11));
                                            rest_2 = tail(tail(input_11));
                                        }
                                        else if (head(tail(input_11)) === "#") {
                                            pattern_matching_result_11 = 0;
                                            c_2 = head(tail(input_11));
                                            rest_2 = tail(tail(input_11));
                                        }
                                        else if (head(tail(input_11)) === "$") {
                                            pattern_matching_result_11 = 0;
                                            c_2 = head(tail(input_11));
                                            rest_2 = tail(tail(input_11));
                                        }
                                        else if (head(tail(input_11)) === "(") {
                                            pattern_matching_result_11 = 0;
                                            c_2 = head(tail(input_11));
                                            rest_2 = tail(tail(input_11));
                                        }
                                        else if (head(tail(input_11)) === ")") {
                                            pattern_matching_result_11 = 0;
                                            c_2 = head(tail(input_11));
                                            rest_2 = tail(tail(input_11));
                                        }
                                        else if (head(tail(input_11)) === "*") {
                                            pattern_matching_result_11 = 0;
                                            c_2 = head(tail(input_11));
                                            rest_2 = tail(tail(input_11));
                                        }
                                        else if (head(tail(input_11)) === "+") {
                                            pattern_matching_result_11 = 0;
                                            c_2 = head(tail(input_11));
                                            rest_2 = tail(tail(input_11));
                                        }
                                        else if (head(tail(input_11)) === "-") {
                                            pattern_matching_result_11 = 0;
                                            c_2 = head(tail(input_11));
                                            rest_2 = tail(tail(input_11));
                                        }
                                        else if (head(tail(input_11)) === ".") {
                                            pattern_matching_result_11 = 0;
                                            c_2 = head(tail(input_11));
                                            rest_2 = tail(tail(input_11));
                                        }
                                        else if (head(tail(input_11)) === "\u003e") {
                                            pattern_matching_result_11 = 0;
                                            c_2 = head(tail(input_11));
                                            rest_2 = tail(tail(input_11));
                                        }
                                        else if (head(tail(input_11)) === "[") {
                                            pattern_matching_result_11 = 0;
                                            c_2 = head(tail(input_11));
                                            rest_2 = tail(tail(input_11));
                                        }
                                        else if (head(tail(input_11)) === "\\") {
                                            pattern_matching_result_11 = 0;
                                            c_2 = head(tail(input_11));
                                            rest_2 = tail(tail(input_11));
                                        }
                                        else if (head(tail(input_11)) === "]") {
                                            pattern_matching_result_11 = 0;
                                            c_2 = head(tail(input_11));
                                            rest_2 = tail(tail(input_11));
                                        }
                                        else if (head(tail(input_11)) === "_") {
                                            pattern_matching_result_11 = 0;
                                            c_2 = head(tail(input_11));
                                            rest_2 = tail(tail(input_11));
                                        }
                                        else if (head(tail(input_11)) === "`") {
                                            pattern_matching_result_11 = 0;
                                            c_2 = head(tail(input_11));
                                            rest_2 = tail(tail(input_11));
                                        }
                                        else if (head(tail(input_11)) === "{") {
                                            pattern_matching_result_11 = 0;
                                            c_2 = head(tail(input_11));
                                            rest_2 = tail(tail(input_11));
                                        }
                                        else if (head(tail(input_11)) === "}") {
                                            pattern_matching_result_11 = 0;
                                            c_2 = head(tail(input_11));
                                            rest_2 = tail(tail(input_11));
                                        }
                                        else {
                                            pattern_matching_result_11 = 1;
                                        }
                                    }
                                    else {
                                        pattern_matching_result_11 = 1;
                                    }
                                }
                                else {
                                    pattern_matching_result_11 = 1;
                                }
                            }
                            else {
                                pattern_matching_result_11 = 1;
                            }
                            switch (pattern_matching_result_11) {
                                case 0: {
                                    activePatternResult_9 = [c_2, rest_2];
                                    break;
                                }
                                case 1: {
                                    activePatternResult_9 = (void 0);
                                    break;
                                }
                            }
                            if (activePatternResult_9 != null) {
                                pattern_matching_result = 3;
                                c_6 = activePatternResult_9[0];
                                rest_9 = activePatternResult_9[1];
                            }
                            else {
                                let activePatternResult_10;
                                const startl_4 = ofArray(["`", " "]);
                                const endl_4 = ofArray([" ", "`"]);
                                const input_12 = matchValue_2;
                                if ((loop_4 = ((start_1_4_mut, list_1_5_mut) => {
                                    loop_4:
                                    while (true) {
                                        const start_1_4 = start_1_4_mut, list_1_5 = list_1_5_mut;
                                        const matchValue_11 = [start_1_4, list_1_5];
                                        let pattern_matching_result_12, x_1_4, xs_1_4, y_1_4, ys_1_4;
                                        if (isEmpty(matchValue_11[0])) {
                                            pattern_matching_result_12 = 1;
                                        }
                                        else if (!isEmpty(matchValue_11[1])) {
                                            if (head(matchValue_11[0]) === head(matchValue_11[1])) {
                                                pattern_matching_result_12 = 0;
                                                x_1_4 = head(matchValue_11[0]);
                                                xs_1_4 = tail(matchValue_11[0]);
                                                y_1_4 = head(matchValue_11[1]);
                                                ys_1_4 = tail(matchValue_11[1]);
                                            }
                                            else {
                                                pattern_matching_result_12 = 2;
                                            }
                                        }
                                        else {
                                            pattern_matching_result_12 = 2;
                                        }
                                        switch (pattern_matching_result_12) {
                                            case 0: {
                                                start_1_4_mut = xs_1_4;
                                                list_1_5_mut = ys_1_4;
                                                continue loop_4;
                                            }
                                            case 1: {
                                                return true;
                                            }
                                            case 2: {
                                                return false;
                                            }
                                        }
                                        break;
                                    }
                                }), loop_4(startl_4, input_12))) {
                                    const matchValue_12 = List_partitionUntilEquals(endl_4, skip(length(startl_4), input_12));
                                    if (matchValue_12 == null) {
                                        activePatternResult_10 = (void 0);
                                    }
                                    else {
                                        const post_4 = matchValue_12[1];
                                        activePatternResult_10 = [matchValue_12[0], skip(length(endl_4), post_4), length(startl_4), length(endl_4)];
                                    }
                                }
                                else {
                                    activePatternResult_10 = (void 0);
                                }
                                if (activePatternResult_10 != null) {
                                    pattern_matching_result = 4;
                                    body = activePatternResult_10[0];
                                    e = activePatternResult_10[3];
                                    rest_10 = activePatternResult_10[1];
                                    s = activePatternResult_10[2];
                                }
                                else {
                                    let activePatternResult_11;
                                    const str_4 = "`";
                                    const input_13 = matchValue_2;
                                    const strs_2 = List_partitionWhile((i_2) => (i_2 === str_4), input_13)[0];
                                    activePatternResult_11 = ((!isEmpty(strs_2)) ? ((str_5 = initialize(length(strs_2), (_arg_2) => str_4), (input_14) => {
                                        let loop_5;
                                        const startl_5 = str_5;
                                        const endl_5 = str_5;
                                        const input_15 = input_14;
                                        if ((loop_5 = ((start_1_5_mut, list_1_6_mut) => {
                                            loop_5:
                                            while (true) {
                                                const start_1_5 = start_1_5_mut, list_1_6 = list_1_6_mut;
                                                const matchValue_13 = [start_1_5, list_1_6];
                                                let pattern_matching_result_13, x_1_5, xs_1_5, y_1_5, ys_1_5;
                                                if (isEmpty(matchValue_13[0])) {
                                                    pattern_matching_result_13 = 1;
                                                }
                                                else if (!isEmpty(matchValue_13[1])) {
                                                    if (head(matchValue_13[0]) === head(matchValue_13[1])) {
                                                        pattern_matching_result_13 = 0;
                                                        x_1_5 = head(matchValue_13[0]);
                                                        xs_1_5 = tail(matchValue_13[0]);
                                                        y_1_5 = head(matchValue_13[1]);
                                                        ys_1_5 = tail(matchValue_13[1]);
                                                    }
                                                    else {
                                                        pattern_matching_result_13 = 2;
                                                    }
                                                }
                                                else {
                                                    pattern_matching_result_13 = 2;
                                                }
                                                switch (pattern_matching_result_13) {
                                                    case 0: {
                                                        start_1_5_mut = xs_1_5;
                                                        list_1_6_mut = ys_1_5;
                                                        continue loop_5;
                                                    }
                                                    case 1: {
                                                        return true;
                                                    }
                                                    case 2: {
                                                        return false;
                                                    }
                                                }
                                                break;
                                            }
                                        }), loop_5(startl_5, input_15))) {
                                            const matchValue_14 = List_partitionUntilEquals(endl_5, skip(length(startl_5), input_15));
                                            if (matchValue_14 == null) {
                                                return void 0;
                                            }
                                            else {
                                                const post_5 = matchValue_14[1];
                                                return [matchValue_14[0], skip(length(endl_5), post_5), length(startl_5), length(endl_5)];
                                            }
                                        }
                                        else {
                                            return void 0;
                                        }
                                    }))(input_13) : (void 0));
                                    if (activePatternResult_11 != null) {
                                        pattern_matching_result = 4;
                                        body = activePatternResult_11[0];
                                        e = activePatternResult_11[3];
                                        rest_10 = activePatternResult_11[1];
                                        s = activePatternResult_11[2];
                                    }
                                    else {
                                        pattern_matching_result = 5;
                                    }
                                }
                            }
                        }
                    }
                }
                else {
                    const activePatternResult_12 = $007CHtmlEntity$007C_$007C(matchValue_2);
                    if (activePatternResult_12 != null) {
                        pattern_matching_result = 1;
                        entity = activePatternResult_12[0];
                        rest_7 = activePatternResult_12[1];
                    }
                    else {
                        let activePatternResult_13;
                        const input_16 = matchValue_2;
                        let pattern_matching_result_14, c_3, rest_3;
                        if (!isEmpty(input_16)) {
                            if (head(input_16) === "\\") {
                                if (!isEmpty(tail(input_16))) {
                                    if (head(tail(input_16)) === "!") {
                                        pattern_matching_result_14 = 0;
                                        c_3 = head(tail(input_16));
                                        rest_3 = tail(tail(input_16));
                                    }
                                    else if (head(tail(input_16)) === "#") {
                                        pattern_matching_result_14 = 0;
                                        c_3 = head(tail(input_16));
                                        rest_3 = tail(tail(input_16));
                                    }
                                    else if (head(tail(input_16)) === "$") {
                                        pattern_matching_result_14 = 0;
                                        c_3 = head(tail(input_16));
                                        rest_3 = tail(tail(input_16));
                                    }
                                    else if (head(tail(input_16)) === "(") {
                                        pattern_matching_result_14 = 0;
                                        c_3 = head(tail(input_16));
                                        rest_3 = tail(tail(input_16));
                                    }
                                    else if (head(tail(input_16)) === ")") {
                                        pattern_matching_result_14 = 0;
                                        c_3 = head(tail(input_16));
                                        rest_3 = tail(tail(input_16));
                                    }
                                    else if (head(tail(input_16)) === "*") {
                                        pattern_matching_result_14 = 0;
                                        c_3 = head(tail(input_16));
                                        rest_3 = tail(tail(input_16));
                                    }
                                    else if (head(tail(input_16)) === "+") {
                                        pattern_matching_result_14 = 0;
                                        c_3 = head(tail(input_16));
                                        rest_3 = tail(tail(input_16));
                                    }
                                    else if (head(tail(input_16)) === "-") {
                                        pattern_matching_result_14 = 0;
                                        c_3 = head(tail(input_16));
                                        rest_3 = tail(tail(input_16));
                                    }
                                    else if (head(tail(input_16)) === ".") {
                                        pattern_matching_result_14 = 0;
                                        c_3 = head(tail(input_16));
                                        rest_3 = tail(tail(input_16));
                                    }
                                    else if (head(tail(input_16)) === "\u003e") {
                                        pattern_matching_result_14 = 0;
                                        c_3 = head(tail(input_16));
                                        rest_3 = tail(tail(input_16));
                                    }
                                    else if (head(tail(input_16)) === "[") {
                                        pattern_matching_result_14 = 0;
                                        c_3 = head(tail(input_16));
                                        rest_3 = tail(tail(input_16));
                                    }
                                    else if (head(tail(input_16)) === "\\") {
                                        pattern_matching_result_14 = 0;
                                        c_3 = head(tail(input_16));
                                        rest_3 = tail(tail(input_16));
                                    }
                                    else if (head(tail(input_16)) === "]") {
                                        pattern_matching_result_14 = 0;
                                        c_3 = head(tail(input_16));
                                        rest_3 = tail(tail(input_16));
                                    }
                                    else if (head(tail(input_16)) === "_") {
                                        pattern_matching_result_14 = 0;
                                        c_3 = head(tail(input_16));
                                        rest_3 = tail(tail(input_16));
                                    }
                                    else if (head(tail(input_16)) === "`") {
                                        pattern_matching_result_14 = 0;
                                        c_3 = head(tail(input_16));
                                        rest_3 = tail(tail(input_16));
                                    }
                                    else if (head(tail(input_16)) === "{") {
                                        pattern_matching_result_14 = 0;
                                        c_3 = head(tail(input_16));
                                        rest_3 = tail(tail(input_16));
                                    }
                                    else if (head(tail(input_16)) === "}") {
                                        pattern_matching_result_14 = 0;
                                        c_3 = head(tail(input_16));
                                        rest_3 = tail(tail(input_16));
                                    }
                                    else {
                                        pattern_matching_result_14 = 1;
                                    }
                                }
                                else {
                                    pattern_matching_result_14 = 1;
                                }
                            }
                            else {
                                pattern_matching_result_14 = 1;
                            }
                        }
                        else {
                            pattern_matching_result_14 = 1;
                        }
                        switch (pattern_matching_result_14) {
                            case 0: {
                                activePatternResult_13 = [c_3, rest_3];
                                break;
                            }
                            case 1: {
                                activePatternResult_13 = (void 0);
                                break;
                            }
                        }
                        if (activePatternResult_13 != null) {
                            pattern_matching_result = 3;
                            c_6 = activePatternResult_13[0];
                            rest_9 = activePatternResult_13[1];
                        }
                        else {
                            let activePatternResult_14;
                            const startl_6 = ofArray(["`", " "]);
                            const endl_6 = ofArray([" ", "`"]);
                            const input_17 = matchValue_2;
                            if ((loop_6 = ((start_1_6_mut, list_1_7_mut) => {
                                loop_6:
                                while (true) {
                                    const start_1_6 = start_1_6_mut, list_1_7 = list_1_7_mut;
                                    const matchValue_15 = [start_1_6, list_1_7];
                                    let pattern_matching_result_15, x_1_6, xs_1_6, y_1_6, ys_1_6;
                                    if (isEmpty(matchValue_15[0])) {
                                        pattern_matching_result_15 = 1;
                                    }
                                    else if (!isEmpty(matchValue_15[1])) {
                                        if (head(matchValue_15[0]) === head(matchValue_15[1])) {
                                            pattern_matching_result_15 = 0;
                                            x_1_6 = head(matchValue_15[0]);
                                            xs_1_6 = tail(matchValue_15[0]);
                                            y_1_6 = head(matchValue_15[1]);
                                            ys_1_6 = tail(matchValue_15[1]);
                                        }
                                        else {
                                            pattern_matching_result_15 = 2;
                                        }
                                    }
                                    else {
                                        pattern_matching_result_15 = 2;
                                    }
                                    switch (pattern_matching_result_15) {
                                        case 0: {
                                            start_1_6_mut = xs_1_6;
                                            list_1_7_mut = ys_1_6;
                                            continue loop_6;
                                        }
                                        case 1: {
                                            return true;
                                        }
                                        case 2: {
                                            return false;
                                        }
                                    }
                                    break;
                                }
                            }), loop_6(startl_6, input_17))) {
                                const matchValue_16 = List_partitionUntilEquals(endl_6, skip(length(startl_6), input_17));
                                if (matchValue_16 == null) {
                                    activePatternResult_14 = (void 0);
                                }
                                else {
                                    const post_6 = matchValue_16[1];
                                    activePatternResult_14 = [matchValue_16[0], skip(length(endl_6), post_6), length(startl_6), length(endl_6)];
                                }
                            }
                            else {
                                activePatternResult_14 = (void 0);
                            }
                            if (activePatternResult_14 != null) {
                                pattern_matching_result = 4;
                                body = activePatternResult_14[0];
                                e = activePatternResult_14[3];
                                rest_10 = activePatternResult_14[1];
                                s = activePatternResult_14[2];
                            }
                            else {
                                let activePatternResult_15;
                                const str_6 = "`";
                                const input_18 = matchValue_2;
                                const strs_3 = List_partitionWhile((i_3) => (i_3 === str_6), input_18)[0];
                                activePatternResult_15 = ((!isEmpty(strs_3)) ? ((str_7 = initialize(length(strs_3), (_arg_3) => str_6), (input_19) => {
                                    let loop_7;
                                    const startl_7 = str_7;
                                    const endl_7 = str_7;
                                    const input_20 = input_19;
                                    if ((loop_7 = ((start_1_7_mut, list_1_8_mut) => {
                                        loop_7:
                                        while (true) {
                                            const start_1_7 = start_1_7_mut, list_1_8 = list_1_8_mut;
                                            const matchValue_17 = [start_1_7, list_1_8];
                                            let pattern_matching_result_16, x_1_7, xs_1_7, y_1_7, ys_1_7;
                                            if (isEmpty(matchValue_17[0])) {
                                                pattern_matching_result_16 = 1;
                                            }
                                            else if (!isEmpty(matchValue_17[1])) {
                                                if (head(matchValue_17[0]) === head(matchValue_17[1])) {
                                                    pattern_matching_result_16 = 0;
                                                    x_1_7 = head(matchValue_17[0]);
                                                    xs_1_7 = tail(matchValue_17[0]);
                                                    y_1_7 = head(matchValue_17[1]);
                                                    ys_1_7 = tail(matchValue_17[1]);
                                                }
                                                else {
                                                    pattern_matching_result_16 = 2;
                                                }
                                            }
                                            else {
                                                pattern_matching_result_16 = 2;
                                            }
                                            switch (pattern_matching_result_16) {
                                                case 0: {
                                                    start_1_7_mut = xs_1_7;
                                                    list_1_8_mut = ys_1_7;
                                                    continue loop_7;
                                                }
                                                case 1: {
                                                    return true;
                                                }
                                                case 2: {
                                                    return false;
                                                }
                                            }
                                            break;
                                        }
                                    }), loop_7(startl_7, input_20))) {
                                        const matchValue_18 = List_partitionUntilEquals(endl_7, skip(length(startl_7), input_20));
                                        if (matchValue_18 == null) {
                                            return void 0;
                                        }
                                        else {
                                            const post_7 = matchValue_18[1];
                                            return [matchValue_18[0], skip(length(endl_7), post_7), length(startl_7), length(endl_7)];
                                        }
                                    }
                                    else {
                                        return void 0;
                                    }
                                }))(input_18) : (void 0));
                                if (activePatternResult_15 != null) {
                                    pattern_matching_result = 4;
                                    body = activePatternResult_15[0];
                                    e = activePatternResult_15[3];
                                    rest_10 = activePatternResult_15[1];
                                    s = activePatternResult_15[2];
                                }
                                else {
                                    pattern_matching_result = 5;
                                }
                            }
                        }
                    }
                }
            }
            else if (head(matchValue_2) === "\u0026") {
                const activePatternResult_16 = $007CHtmlEntity$007C_$007C(matchValue_2);
                if (activePatternResult_16 != null) {
                    pattern_matching_result = 1;
                    entity = activePatternResult_16[0];
                    rest_7 = activePatternResult_16[1];
                }
                else {
                    pattern_matching_result = 2;
                    rest_8 = tail(matchValue_2);
                }
            }
            else {
                const activePatternResult_17 = $007CHtmlEntity$007C_$007C(matchValue_2);
                if (activePatternResult_17 != null) {
                    pattern_matching_result = 1;
                    entity = activePatternResult_17[0];
                    rest_7 = activePatternResult_17[1];
                }
                else {
                    let activePatternResult_18;
                    const input_21 = matchValue_2;
                    let pattern_matching_result_17, c_4, rest_4;
                    if (!isEmpty(input_21)) {
                        if (head(input_21) === "\\") {
                            if (!isEmpty(tail(input_21))) {
                                if (head(tail(input_21)) === "!") {
                                    pattern_matching_result_17 = 0;
                                    c_4 = head(tail(input_21));
                                    rest_4 = tail(tail(input_21));
                                }
                                else if (head(tail(input_21)) === "#") {
                                    pattern_matching_result_17 = 0;
                                    c_4 = head(tail(input_21));
                                    rest_4 = tail(tail(input_21));
                                }
                                else if (head(tail(input_21)) === "$") {
                                    pattern_matching_result_17 = 0;
                                    c_4 = head(tail(input_21));
                                    rest_4 = tail(tail(input_21));
                                }
                                else if (head(tail(input_21)) === "(") {
                                    pattern_matching_result_17 = 0;
                                    c_4 = head(tail(input_21));
                                    rest_4 = tail(tail(input_21));
                                }
                                else if (head(tail(input_21)) === ")") {
                                    pattern_matching_result_17 = 0;
                                    c_4 = head(tail(input_21));
                                    rest_4 = tail(tail(input_21));
                                }
                                else if (head(tail(input_21)) === "*") {
                                    pattern_matching_result_17 = 0;
                                    c_4 = head(tail(input_21));
                                    rest_4 = tail(tail(input_21));
                                }
                                else if (head(tail(input_21)) === "+") {
                                    pattern_matching_result_17 = 0;
                                    c_4 = head(tail(input_21));
                                    rest_4 = tail(tail(input_21));
                                }
                                else if (head(tail(input_21)) === "-") {
                                    pattern_matching_result_17 = 0;
                                    c_4 = head(tail(input_21));
                                    rest_4 = tail(tail(input_21));
                                }
                                else if (head(tail(input_21)) === ".") {
                                    pattern_matching_result_17 = 0;
                                    c_4 = head(tail(input_21));
                                    rest_4 = tail(tail(input_21));
                                }
                                else if (head(tail(input_21)) === "\u003e") {
                                    pattern_matching_result_17 = 0;
                                    c_4 = head(tail(input_21));
                                    rest_4 = tail(tail(input_21));
                                }
                                else if (head(tail(input_21)) === "[") {
                                    pattern_matching_result_17 = 0;
                                    c_4 = head(tail(input_21));
                                    rest_4 = tail(tail(input_21));
                                }
                                else if (head(tail(input_21)) === "\\") {
                                    pattern_matching_result_17 = 0;
                                    c_4 = head(tail(input_21));
                                    rest_4 = tail(tail(input_21));
                                }
                                else if (head(tail(input_21)) === "]") {
                                    pattern_matching_result_17 = 0;
                                    c_4 = head(tail(input_21));
                                    rest_4 = tail(tail(input_21));
                                }
                                else if (head(tail(input_21)) === "_") {
                                    pattern_matching_result_17 = 0;
                                    c_4 = head(tail(input_21));
                                    rest_4 = tail(tail(input_21));
                                }
                                else if (head(tail(input_21)) === "`") {
                                    pattern_matching_result_17 = 0;
                                    c_4 = head(tail(input_21));
                                    rest_4 = tail(tail(input_21));
                                }
                                else if (head(tail(input_21)) === "{") {
                                    pattern_matching_result_17 = 0;
                                    c_4 = head(tail(input_21));
                                    rest_4 = tail(tail(input_21));
                                }
                                else if (head(tail(input_21)) === "}") {
                                    pattern_matching_result_17 = 0;
                                    c_4 = head(tail(input_21));
                                    rest_4 = tail(tail(input_21));
                                }
                                else {
                                    pattern_matching_result_17 = 1;
                                }
                            }
                            else {
                                pattern_matching_result_17 = 1;
                            }
                        }
                        else {
                            pattern_matching_result_17 = 1;
                        }
                    }
                    else {
                        pattern_matching_result_17 = 1;
                    }
                    switch (pattern_matching_result_17) {
                        case 0: {
                            activePatternResult_18 = [c_4, rest_4];
                            break;
                        }
                        case 1: {
                            activePatternResult_18 = (void 0);
                            break;
                        }
                    }
                    if (activePatternResult_18 != null) {
                        pattern_matching_result = 3;
                        c_6 = activePatternResult_18[0];
                        rest_9 = activePatternResult_18[1];
                    }
                    else {
                        let activePatternResult_19;
                        const startl_8 = ofArray(["`", " "]);
                        const endl_8 = ofArray([" ", "`"]);
                        const input_22 = matchValue_2;
                        if ((loop_8 = ((start_1_8_mut, list_1_9_mut) => {
                            loop_8:
                            while (true) {
                                const start_1_8 = start_1_8_mut, list_1_9 = list_1_9_mut;
                                const matchValue_19 = [start_1_8, list_1_9];
                                let pattern_matching_result_18, x_1_8, xs_1_8, y_1_8, ys_1_8;
                                if (isEmpty(matchValue_19[0])) {
                                    pattern_matching_result_18 = 1;
                                }
                                else if (!isEmpty(matchValue_19[1])) {
                                    if (head(matchValue_19[0]) === head(matchValue_19[1])) {
                                        pattern_matching_result_18 = 0;
                                        x_1_8 = head(matchValue_19[0]);
                                        xs_1_8 = tail(matchValue_19[0]);
                                        y_1_8 = head(matchValue_19[1]);
                                        ys_1_8 = tail(matchValue_19[1]);
                                    }
                                    else {
                                        pattern_matching_result_18 = 2;
                                    }
                                }
                                else {
                                    pattern_matching_result_18 = 2;
                                }
                                switch (pattern_matching_result_18) {
                                    case 0: {
                                        start_1_8_mut = xs_1_8;
                                        list_1_9_mut = ys_1_8;
                                        continue loop_8;
                                    }
                                    case 1: {
                                        return true;
                                    }
                                    case 2: {
                                        return false;
                                    }
                                }
                                break;
                            }
                        }), loop_8(startl_8, input_22))) {
                            const matchValue_20 = List_partitionUntilEquals(endl_8, skip(length(startl_8), input_22));
                            if (matchValue_20 == null) {
                                activePatternResult_19 = (void 0);
                            }
                            else {
                                const post_8 = matchValue_20[1];
                                activePatternResult_19 = [matchValue_20[0], skip(length(endl_8), post_8), length(startl_8), length(endl_8)];
                            }
                        }
                        else {
                            activePatternResult_19 = (void 0);
                        }
                        if (activePatternResult_19 != null) {
                            pattern_matching_result = 4;
                            body = activePatternResult_19[0];
                            e = activePatternResult_19[3];
                            rest_10 = activePatternResult_19[1];
                            s = activePatternResult_19[2];
                        }
                        else {
                            let activePatternResult_20;
                            const str_8 = "`";
                            const input_23 = matchValue_2;
                            const strs_4 = List_partitionWhile((i_4) => (i_4 === str_8), input_23)[0];
                            activePatternResult_20 = ((!isEmpty(strs_4)) ? ((str_9 = initialize(length(strs_4), (_arg_4) => str_8), (input_24) => {
                                let loop_9;
                                const startl_9 = str_9;
                                const endl_9 = str_9;
                                const input_25 = input_24;
                                if ((loop_9 = ((start_1_9_mut, list_1_10_mut) => {
                                    loop_9:
                                    while (true) {
                                        const start_1_9 = start_1_9_mut, list_1_10 = list_1_10_mut;
                                        const matchValue_21 = [start_1_9, list_1_10];
                                        let pattern_matching_result_19, x_1_9, xs_1_9, y_1_9, ys_1_9;
                                        if (isEmpty(matchValue_21[0])) {
                                            pattern_matching_result_19 = 1;
                                        }
                                        else if (!isEmpty(matchValue_21[1])) {
                                            if (head(matchValue_21[0]) === head(matchValue_21[1])) {
                                                pattern_matching_result_19 = 0;
                                                x_1_9 = head(matchValue_21[0]);
                                                xs_1_9 = tail(matchValue_21[0]);
                                                y_1_9 = head(matchValue_21[1]);
                                                ys_1_9 = tail(matchValue_21[1]);
                                            }
                                            else {
                                                pattern_matching_result_19 = 2;
                                            }
                                        }
                                        else {
                                            pattern_matching_result_19 = 2;
                                        }
                                        switch (pattern_matching_result_19) {
                                            case 0: {
                                                start_1_9_mut = xs_1_9;
                                                list_1_10_mut = ys_1_9;
                                                continue loop_9;
                                            }
                                            case 1: {
                                                return true;
                                            }
                                            case 2: {
                                                return false;
                                            }
                                        }
                                        break;
                                    }
                                }), loop_9(startl_9, input_25))) {
                                    const matchValue_22 = List_partitionUntilEquals(endl_9, skip(length(startl_9), input_25));
                                    if (matchValue_22 == null) {
                                        return void 0;
                                    }
                                    else {
                                        const post_9 = matchValue_22[1];
                                        return [matchValue_22[0], skip(length(endl_9), post_9), length(startl_9), length(endl_9)];
                                    }
                                }
                                else {
                                    return void 0;
                                }
                            }))(input_23) : (void 0));
                            if (activePatternResult_20 != null) {
                                pattern_matching_result = 4;
                                body = activePatternResult_20[0];
                                e = activePatternResult_20[3];
                                rest_10 = activePatternResult_20[1];
                                s = activePatternResult_20[2];
                            }
                            else {
                                pattern_matching_result = 5;
                            }
                        }
                    }
                }
            }
        }
        else {
            const activePatternResult_21 = $007CHtmlEntity$007C_$007C(matchValue_2);
            if (activePatternResult_21 != null) {
                pattern_matching_result = 1;
                entity = activePatternResult_21[0];
                rest_7 = activePatternResult_21[1];
            }
            else {
                let activePatternResult_22;
                const input_26 = matchValue_2;
                let pattern_matching_result_20, c_5, rest_5;
                if (!isEmpty(input_26)) {
                    if (head(input_26) === "\\") {
                        if (!isEmpty(tail(input_26))) {
                            if (head(tail(input_26)) === "!") {
                                pattern_matching_result_20 = 0;
                                c_5 = head(tail(input_26));
                                rest_5 = tail(tail(input_26));
                            }
                            else if (head(tail(input_26)) === "#") {
                                pattern_matching_result_20 = 0;
                                c_5 = head(tail(input_26));
                                rest_5 = tail(tail(input_26));
                            }
                            else if (head(tail(input_26)) === "$") {
                                pattern_matching_result_20 = 0;
                                c_5 = head(tail(input_26));
                                rest_5 = tail(tail(input_26));
                            }
                            else if (head(tail(input_26)) === "(") {
                                pattern_matching_result_20 = 0;
                                c_5 = head(tail(input_26));
                                rest_5 = tail(tail(input_26));
                            }
                            else if (head(tail(input_26)) === ")") {
                                pattern_matching_result_20 = 0;
                                c_5 = head(tail(input_26));
                                rest_5 = tail(tail(input_26));
                            }
                            else if (head(tail(input_26)) === "*") {
                                pattern_matching_result_20 = 0;
                                c_5 = head(tail(input_26));
                                rest_5 = tail(tail(input_26));
                            }
                            else if (head(tail(input_26)) === "+") {
                                pattern_matching_result_20 = 0;
                                c_5 = head(tail(input_26));
                                rest_5 = tail(tail(input_26));
                            }
                            else if (head(tail(input_26)) === "-") {
                                pattern_matching_result_20 = 0;
                                c_5 = head(tail(input_26));
                                rest_5 = tail(tail(input_26));
                            }
                            else if (head(tail(input_26)) === ".") {
                                pattern_matching_result_20 = 0;
                                c_5 = head(tail(input_26));
                                rest_5 = tail(tail(input_26));
                            }
                            else if (head(tail(input_26)) === "\u003e") {
                                pattern_matching_result_20 = 0;
                                c_5 = head(tail(input_26));
                                rest_5 = tail(tail(input_26));
                            }
                            else if (head(tail(input_26)) === "[") {
                                pattern_matching_result_20 = 0;
                                c_5 = head(tail(input_26));
                                rest_5 = tail(tail(input_26));
                            }
                            else if (head(tail(input_26)) === "\\") {
                                pattern_matching_result_20 = 0;
                                c_5 = head(tail(input_26));
                                rest_5 = tail(tail(input_26));
                            }
                            else if (head(tail(input_26)) === "]") {
                                pattern_matching_result_20 = 0;
                                c_5 = head(tail(input_26));
                                rest_5 = tail(tail(input_26));
                            }
                            else if (head(tail(input_26)) === "_") {
                                pattern_matching_result_20 = 0;
                                c_5 = head(tail(input_26));
                                rest_5 = tail(tail(input_26));
                            }
                            else if (head(tail(input_26)) === "`") {
                                pattern_matching_result_20 = 0;
                                c_5 = head(tail(input_26));
                                rest_5 = tail(tail(input_26));
                            }
                            else if (head(tail(input_26)) === "{") {
                                pattern_matching_result_20 = 0;
                                c_5 = head(tail(input_26));
                                rest_5 = tail(tail(input_26));
                            }
                            else if (head(tail(input_26)) === "}") {
                                pattern_matching_result_20 = 0;
                                c_5 = head(tail(input_26));
                                rest_5 = tail(tail(input_26));
                            }
                            else {
                                pattern_matching_result_20 = 1;
                            }
                        }
                        else {
                            pattern_matching_result_20 = 1;
                        }
                    }
                    else {
                        pattern_matching_result_20 = 1;
                    }
                }
                else {
                    pattern_matching_result_20 = 1;
                }
                switch (pattern_matching_result_20) {
                    case 0: {
                        activePatternResult_22 = [c_5, rest_5];
                        break;
                    }
                    case 1: {
                        activePatternResult_22 = (void 0);
                        break;
                    }
                }
                if (activePatternResult_22 != null) {
                    pattern_matching_result = 3;
                    c_6 = activePatternResult_22[0];
                    rest_9 = activePatternResult_22[1];
                }
                else {
                    let activePatternResult_23;
                    const startl_10 = ofArray(["`", " "]);
                    const endl_10 = ofArray([" ", "`"]);
                    const input_27 = matchValue_2;
                    if ((loop_10 = ((start_1_10_mut, list_1_11_mut) => {
                        loop_10:
                        while (true) {
                            const start_1_10 = start_1_10_mut, list_1_11 = list_1_11_mut;
                            const matchValue_23 = [start_1_10, list_1_11];
                            let pattern_matching_result_21, x_1_10, xs_1_10, y_1_10, ys_1_10;
                            if (isEmpty(matchValue_23[0])) {
                                pattern_matching_result_21 = 1;
                            }
                            else if (!isEmpty(matchValue_23[1])) {
                                if (head(matchValue_23[0]) === head(matchValue_23[1])) {
                                    pattern_matching_result_21 = 0;
                                    x_1_10 = head(matchValue_23[0]);
                                    xs_1_10 = tail(matchValue_23[0]);
                                    y_1_10 = head(matchValue_23[1]);
                                    ys_1_10 = tail(matchValue_23[1]);
                                }
                                else {
                                    pattern_matching_result_21 = 2;
                                }
                            }
                            else {
                                pattern_matching_result_21 = 2;
                            }
                            switch (pattern_matching_result_21) {
                                case 0: {
                                    start_1_10_mut = xs_1_10;
                                    list_1_11_mut = ys_1_10;
                                    continue loop_10;
                                }
                                case 1: {
                                    return true;
                                }
                                case 2: {
                                    return false;
                                }
                            }
                            break;
                        }
                    }), loop_10(startl_10, input_27))) {
                        const matchValue_24 = List_partitionUntilEquals(endl_10, skip(length(startl_10), input_27));
                        if (matchValue_24 == null) {
                            activePatternResult_23 = (void 0);
                        }
                        else {
                            const post_10 = matchValue_24[1];
                            activePatternResult_23 = [matchValue_24[0], skip(length(endl_10), post_10), length(startl_10), length(endl_10)];
                        }
                    }
                    else {
                        activePatternResult_23 = (void 0);
                    }
                    if (activePatternResult_23 != null) {
                        pattern_matching_result = 4;
                        body = activePatternResult_23[0];
                        e = activePatternResult_23[3];
                        rest_10 = activePatternResult_23[1];
                        s = activePatternResult_23[2];
                    }
                    else {
                        let activePatternResult_24;
                        const str_10 = "`";
                        const input_28 = matchValue_2;
                        const strs_5 = List_partitionWhile((i_5) => (i_5 === str_10), input_28)[0];
                        activePatternResult_24 = ((!isEmpty(strs_5)) ? ((str_11 = initialize(length(strs_5), (_arg_5) => str_10), (input_29) => {
                            let loop_11;
                            const startl_11 = str_11;
                            const endl_11 = str_11;
                            const input_30 = input_29;
                            if ((loop_11 = ((start_1_11_mut, list_1_12_mut) => {
                                loop_11:
                                while (true) {
                                    const start_1_11 = start_1_11_mut, list_1_12 = list_1_12_mut;
                                    const matchValue_25 = [start_1_11, list_1_12];
                                    let pattern_matching_result_22, x_1_11, xs_1_11, y_1_11, ys_1_11;
                                    if (isEmpty(matchValue_25[0])) {
                                        pattern_matching_result_22 = 1;
                                    }
                                    else if (!isEmpty(matchValue_25[1])) {
                                        if (head(matchValue_25[0]) === head(matchValue_25[1])) {
                                            pattern_matching_result_22 = 0;
                                            x_1_11 = head(matchValue_25[0]);
                                            xs_1_11 = tail(matchValue_25[0]);
                                            y_1_11 = head(matchValue_25[1]);
                                            ys_1_11 = tail(matchValue_25[1]);
                                        }
                                        else {
                                            pattern_matching_result_22 = 2;
                                        }
                                    }
                                    else {
                                        pattern_matching_result_22 = 2;
                                    }
                                    switch (pattern_matching_result_22) {
                                        case 0: {
                                            start_1_11_mut = xs_1_11;
                                            list_1_12_mut = ys_1_11;
                                            continue loop_11;
                                        }
                                        case 1: {
                                            return true;
                                        }
                                        case 2: {
                                            return false;
                                        }
                                    }
                                    break;
                                }
                            }), loop_11(startl_11, input_30))) {
                                const matchValue_26 = List_partitionUntilEquals(endl_11, skip(length(startl_11), input_30));
                                if (matchValue_26 == null) {
                                    return void 0;
                                }
                                else {
                                    const post_11 = matchValue_26[1];
                                    return [matchValue_26[0], skip(length(endl_11), post_11), length(startl_11), length(endl_11)];
                                }
                            }
                            else {
                                return void 0;
                            }
                        }))(input_28) : (void 0));
                        if (activePatternResult_24 != null) {
                            pattern_matching_result = 4;
                            body = activePatternResult_24[0];
                            e = activePatternResult_24[3];
                            rest_10 = activePatternResult_24[1];
                            s = activePatternResult_24[2];
                        }
                        else {
                            pattern_matching_result = 5;
                        }
                    }
                }
            }
        }
        switch (pattern_matching_result) {
            case 0: {
                const patternInput_6 = accLiterals.Value;
                const ctx_2 = patternInput_6[1];
                return append(patternInput_6[0], delay(() => append(singleton_1(new MarkdownSpan(9, ctx_2.CurrentRange)), delay(() => parseChars(empty(), rest_6, ctx_2)))));
            }
            case 1: {
                const patternInput_7 = accLiterals.Value;
                const ctx_3 = patternInput_7[1];
                return append(patternInput_7[0], delay(() => append(singleton_1(new MarkdownSpan(0, entity, ctx_3.CurrentRange)), delay(() => parseChars(empty(), rest_7, ctx_3)))));
            }
            case 2: {
                return parseChars(ofArrayWithTail([";", "p", "m", "a", "\u0026"], acc), rest_8, ctx);
            }
            case 3: {
                return parseChars(cons(c_6, acc), rest_9, ctx);
            }
            case 4: {
                const patternInput_8 = accLiterals.Value;
                const ctx_4 = patternInput_8[1];
                return append(patternInput_8[0], delay(() => {
                    let inputRecord_2, StartColumn_1, EndColumn_1;
                    let rng;
                    const matchValue_27 = ctx_4.CurrentRange;
                    if (matchValue_27 == null) {
                        rng = (void 0);
                    }
                    else {
                        const n_2 = matchValue_27;
                        rng = ((inputRecord_2 = (new FSharpRef(n_2)), (StartColumn_1 = ((n_2.StartColumn + s) | 0), (EndColumn_1 = ((n_2.EndColumn - e) | 0), new MarkdownRange(inputRecord_2.contents.StartLine, StartColumn_1, inputRecord_2.contents.EndLine, EndColumn_1)))));
                    }
                    return append(singleton_1(new MarkdownSpan(1, (toArray(body).join('')).trim(), rng)), delay(() => parseChars(empty(), rest_10, ctx_4)));
                }));
            }
            case 5: {
                let pattern_matching_result_1, body_1, rest_12, body_2, rest_13, _e_1, _s_1, link_1, rest_14;
                const activePatternResult_25 = $007CDelimitedLatexDisplayMath$007C_$007C(ofArray(["$", "$"]), matchValue_2);
                if (activePatternResult_25 != null) {
                    pattern_matching_result_1 = 0;
                    body_1 = activePatternResult_25[0];
                    rest_12 = activePatternResult_25[1];
                }
                else {
                    const activePatternResult_26 = $007CDelimitedLatexInlineMath$007C_$007C(singleton("$"), matchValue_2);
                    if (activePatternResult_26 != null) {
                        pattern_matching_result_1 = 1;
                        body_2 = activePatternResult_26[0];
                        rest_13 = activePatternResult_26[1];
                    }
                    else {
                        let activePatternResult_27;
                        const startl_12 = singleton("\u003c");
                        const endl_12 = singleton("\u003e");
                        const input_31 = matchValue_2;
                        if ((loop_12 = ((start_1_12_mut, list_1_13_mut) => {
                            loop_12:
                            while (true) {
                                const start_1_12 = start_1_12_mut, list_1_13 = list_1_13_mut;
                                const matchValue_28 = [start_1_12, list_1_13];
                                let pattern_matching_result_4, x_1_12, xs_1_12, y_1_12, ys_1_12;
                                if (isEmpty(matchValue_28[0])) {
                                    pattern_matching_result_4 = 1;
                                }
                                else if (!isEmpty(matchValue_28[1])) {
                                    if (head(matchValue_28[0]) === head(matchValue_28[1])) {
                                        pattern_matching_result_4 = 0;
                                        x_1_12 = head(matchValue_28[0]);
                                        xs_1_12 = tail(matchValue_28[0]);
                                        y_1_12 = head(matchValue_28[1]);
                                        ys_1_12 = tail(matchValue_28[1]);
                                    }
                                    else {
                                        pattern_matching_result_4 = 2;
                                    }
                                }
                                else {
                                    pattern_matching_result_4 = 2;
                                }
                                switch (pattern_matching_result_4) {
                                    case 0: {
                                        start_1_12_mut = xs_1_12;
                                        list_1_13_mut = ys_1_12;
                                        continue loop_12;
                                    }
                                    case 1: {
                                        return true;
                                    }
                                    case 2: {
                                        return false;
                                    }
                                }
                                break;
                            }
                        }), loop_12(startl_12, input_31))) {
                            const matchValue_29 = List_partitionUntilEquals(endl_12, skip(length(startl_12), input_31));
                            if (matchValue_29 == null) {
                                activePatternResult_27 = (void 0);
                            }
                            else {
                                const post_12 = matchValue_29[1];
                                activePatternResult_27 = [matchValue_29[0], skip(length(endl_12), post_12), length(startl_12), length(endl_12)];
                            }
                        }
                        else {
                            activePatternResult_27 = (void 0);
                        }
                        if (activePatternResult_27 != null) {
                            const activePatternResult_28 = List_$007CAsString$007C(activePatternResult_27[0]);
                            if ((rest_11 = activePatternResult_27[1], (link = activePatternResult_28, (_s = (activePatternResult_27[2] | 0), (_e = (activePatternResult_27[3] | 0), forAll((arg_1) => (!isWhiteSpace(arg_1)), link.split("")) && ((link.indexOf("@") >= 0) ? true : (link.indexOf("://") >= 0))))))) {
                                pattern_matching_result_1 = 2;
                                _e_1 = activePatternResult_27[3];
                                _s_1 = activePatternResult_27[2];
                                link_1 = activePatternResult_28;
                                rest_14 = activePatternResult_27[1];
                            }
                            else {
                                pattern_matching_result_1 = 3;
                            }
                        }
                        else {
                            pattern_matching_result_1 = 3;
                        }
                    }
                }
                switch (pattern_matching_result_1) {
                    case 0: {
                        const patternInput_9 = accLiterals.Value;
                        const ctx_5 = patternInput_9[1];
                        return append(patternInput_9[0], delay(() => append(singleton_1(new MarkdownSpan(11, (toArray(body_1).join('')).trim(), ctx_5.CurrentRange)), delay(() => parseChars(empty(), rest_12, ctx_5)))));
                    }
                    case 1: {
                        const patternInput_10 = accLiterals.Value;
                        const ctx_6 = patternInput_10[1];
                        const ctx_7 = new ParsingContext(ctx_6.Links, ctx_6.Newline, ctx_6.IsFirst, (matchValue_30 = ctx_6.CurrentRange, (matchValue_30 == null) ? (void 0) : ((n_3 = matchValue_30, (inputRecord_3 = (new FSharpRef(n_3)), (StartColumn_2 = ((n_3.StartColumn + 1) | 0), new MarkdownRange(inputRecord_3.contents.StartLine, StartColumn_2, inputRecord_3.contents.EndLine, inputRecord_3.contents.EndColumn)))))), ctx_6.ParseOptions);
                        return append(patternInput_10[0], delay(() => {
                            let matchValue_31, n_4, inputRecord_4, EndColumn_2;
                            const code = (toArray(body_2).join('')).trim();
                            return append(singleton_1(new MarkdownSpan(10, code, (matchValue_31 = ctx_7.CurrentRange, (matchValue_31 == null) ? (void 0) : ((n_4 = matchValue_31, (inputRecord_4 = (new FSharpRef(n_4)), (EndColumn_2 = ((n_4.StartColumn + code.length) | 0), new MarkdownRange(inputRecord_4.contents.StartLine, inputRecord_4.contents.StartColumn, inputRecord_4.contents.EndLine, EndColumn_2)))))))), delay(() => parseChars(empty(), rest_13, ctx_7)));
                        }));
                    }
                    case 2: {
                        const patternInput_11 = accLiterals.Value;
                        const ctx_8 = patternInput_11[1];
                        return append(patternInput_11[0], delay(() => append(singleton_1(new MarkdownSpan(5, singleton(new MarkdownSpan(0, link_1, ctx_8.CurrentRange)), link_1, void 0, ctx_8.CurrentRange)), delay(() => parseChars(empty(), rest_14, ctx_8)))));
                    }
                    case 3: {
                        let pattern_matching_result_2, _e_2, _s_2, rest_15, tag, body_3, link_2, rest_16, body_4, link_4, original, rest_17, link_5, rest_18, body_5, link_6, rest_19, body_6, link_8, original_1, rest_20, body_7, f, rest_21, rest_22, rest_23, x_15, xs_15;
                        let activePatternResult_29;
                        const startl_13 = singleton("\u003c");
                        const endl_13 = singleton("\u003e");
                        const input_32 = matchValue_2;
                        if ((loop_13 = ((start_1_13_mut, list_1_14_mut) => {
                            loop_13:
                            while (true) {
                                const start_1_13 = start_1_13_mut, list_1_14 = list_1_14_mut;
                                const matchValue_32 = [start_1_13, list_1_14];
                                let pattern_matching_result_3, x_1_13, xs_1_13, y_1_13, ys_1_13;
                                if (isEmpty(matchValue_32[0])) {
                                    pattern_matching_result_3 = 1;
                                }
                                else if (!isEmpty(matchValue_32[1])) {
                                    if (head(matchValue_32[0]) === head(matchValue_32[1])) {
                                        pattern_matching_result_3 = 0;
                                        x_1_13 = head(matchValue_32[0]);
                                        xs_1_13 = tail(matchValue_32[0]);
                                        y_1_13 = head(matchValue_32[1]);
                                        ys_1_13 = tail(matchValue_32[1]);
                                    }
                                    else {
                                        pattern_matching_result_3 = 2;
                                    }
                                }
                                else {
                                    pattern_matching_result_3 = 2;
                                }
                                switch (pattern_matching_result_3) {
                                    case 0: {
                                        start_1_13_mut = xs_1_13;
                                        list_1_14_mut = ys_1_13;
                                        continue loop_13;
                                    }
                                    case 1: {
                                        return true;
                                    }
                                    case 2: {
                                        return false;
                                    }
                                }
                                break;
                            }
                        }), loop_13(startl_13, input_32))) {
                            const matchValue_33 = List_partitionUntilEquals(endl_13, skip(length(startl_13), input_32));
                            if (matchValue_33 == null) {
                                activePatternResult_29 = (void 0);
                            }
                            else {
                                const post_13 = matchValue_33[1];
                                activePatternResult_29 = [matchValue_33[0], skip(length(endl_13), post_13), length(startl_13), length(endl_13)];
                            }
                        }
                        else {
                            activePatternResult_29 = (void 0);
                        }
                        if (activePatternResult_29 != null) {
                            pattern_matching_result_2 = 0;
                            _e_2 = activePatternResult_29[3];
                            _s_2 = activePatternResult_29[2];
                            rest_15 = activePatternResult_29[1];
                            tag = activePatternResult_29[0];
                        }
                        else {
                            const activePatternResult_30 = $007CDirectLink$007C_$007C(matchValue_2);
                            if (activePatternResult_30 != null) {
                                pattern_matching_result_2 = 1;
                                body_3 = activePatternResult_30[0];
                                link_2 = activePatternResult_30[1];
                                rest_16 = activePatternResult_30[2];
                            }
                            else {
                                const activePatternResult_31 = $007CIndirectLink$007C_$007C(matchValue_2);
                                if (activePatternResult_31 != null) {
                                    pattern_matching_result_2 = 2;
                                    body_4 = activePatternResult_31[0];
                                    link_4 = activePatternResult_31[1];
                                    original = activePatternResult_31[2];
                                    rest_17 = activePatternResult_31[3];
                                }
                                else {
                                    const activePatternResult_32 = $007CAutoLink$007C_$007C(matchValue_2);
                                    if (activePatternResult_32 != null) {
                                        pattern_matching_result_2 = 3;
                                        link_5 = activePatternResult_32[0];
                                        rest_18 = activePatternResult_32[1];
                                    }
                                    else if (isEmpty(matchValue_2)) {
                                        const activePatternResult_33 = $007CEmphasised$007C_$007C(matchValue_2);
                                        if (activePatternResult_33 != null) {
                                            pattern_matching_result_2 = 6;
                                            body_7 = activePatternResult_33[0];
                                            f = activePatternResult_33[1];
                                            rest_21 = activePatternResult_33[2];
                                        }
                                        else {
                                            pattern_matching_result_2 = 10;
                                        }
                                    }
                                    else if (head(matchValue_2) === "!") {
                                        const activePatternResult_34 = $007CDirectLink$007C_$007C(tail(matchValue_2));
                                        if (activePatternResult_34 != null) {
                                            pattern_matching_result_2 = 4;
                                            body_5 = activePatternResult_34[0];
                                            link_6 = activePatternResult_34[1];
                                            rest_19 = activePatternResult_34[2];
                                        }
                                        else {
                                            const activePatternResult_35 = $007CIndirectLink$007C_$007C(tail(matchValue_2));
                                            if (activePatternResult_35 != null) {
                                                pattern_matching_result_2 = 5;
                                                body_6 = activePatternResult_35[0];
                                                link_8 = activePatternResult_35[1];
                                                original_1 = activePatternResult_35[2];
                                                rest_20 = activePatternResult_35[3];
                                            }
                                            else {
                                                const activePatternResult_36 = $007CEmphasised$007C_$007C(matchValue_2);
                                                if (activePatternResult_36 != null) {
                                                    pattern_matching_result_2 = 6;
                                                    body_7 = activePatternResult_36[0];
                                                    f = activePatternResult_36[1];
                                                    rest_21 = activePatternResult_36[2];
                                                }
                                                else {
                                                    pattern_matching_result_2 = 9;
                                                    x_15 = head(matchValue_2);
                                                    xs_15 = tail(matchValue_2);
                                                }
                                            }
                                        }
                                    }
                                    else if (head(matchValue_2) === "\u003c") {
                                        const activePatternResult_37 = $007CEmphasised$007C_$007C(matchValue_2);
                                        if (activePatternResult_37 != null) {
                                            pattern_matching_result_2 = 6;
                                            body_7 = activePatternResult_37[0];
                                            f = activePatternResult_37[1];
                                            rest_21 = activePatternResult_37[2];
                                        }
                                        else {
                                            pattern_matching_result_2 = 7;
                                            rest_22 = tail(matchValue_2);
                                        }
                                    }
                                    else if (head(matchValue_2) === "\u003e") {
                                        const activePatternResult_38 = $007CEmphasised$007C_$007C(matchValue_2);
                                        if (activePatternResult_38 != null) {
                                            pattern_matching_result_2 = 6;
                                            body_7 = activePatternResult_38[0];
                                            f = activePatternResult_38[1];
                                            rest_21 = activePatternResult_38[2];
                                        }
                                        else {
                                            pattern_matching_result_2 = 8;
                                            rest_23 = tail(matchValue_2);
                                        }
                                    }
                                    else {
                                        const activePatternResult_39 = $007CEmphasised$007C_$007C(matchValue_2);
                                        if (activePatternResult_39 != null) {
                                            pattern_matching_result_2 = 6;
                                            body_7 = activePatternResult_39[0];
                                            f = activePatternResult_39[1];
                                            rest_21 = activePatternResult_39[2];
                                        }
                                        else {
                                            pattern_matching_result_2 = 9;
                                            x_15 = head(matchValue_2);
                                            xs_15 = tail(matchValue_2);
                                        }
                                    }
                                }
                            }
                        }
                        switch (pattern_matching_result_2) {
                            case 0: {
                                return parseChars(append_1(cons("\u003e", reverse(tag)), cons("\u003c", acc)), rest_15, ctx);
                            }
                            case 1: {
                                const patternInput_12 = accLiterals.Value;
                                const ctx_9 = patternInput_12[1];
                                return append(patternInput_12[0], delay(() => {
                                    const patternInput_13 = getLinkAndTitle(toArray(link_2).join(''), MarkdownRangeModule_zero);
                                    return append(singleton_1(new MarkdownSpan(5, ofSeq(parseChars(empty(), body_3, ctx_9)), patternInput_13[0], patternInput_13[1], ctx_9.CurrentRange)), delay(() => parseChars(empty(), rest_16, ctx_9)));
                                }));
                            }
                            case 2: {
                                const patternInput_14 = accLiterals.Value;
                                const ctx_10 = patternInput_14[1];
                                return append(patternInput_14[0], delay(() => {
                                    const key = isNullOrEmpty(link_4) ? (Array.from(body_4).join('')) : link_4;
                                    return append(singleton_1(new MarkdownSpan(6, ofSeq(parseChars(empty(), body_4, ctx_10)), original, key, ctx_10.CurrentRange)), delay(() => parseChars(empty(), rest_17, ctx_10)));
                                }));
                            }
                            case 3: {
                                const patternInput_15 = accLiterals.Value;
                                const ctx_11 = patternInput_15[1];
                                return append(patternInput_15[0], delay(() => append(singleton_1(new MarkdownSpan(5, singleton(new MarkdownSpan(0, link_5, ctx_11.CurrentRange)), link_5, void 0, ctx_11.CurrentRange)), delay(() => parseChars(empty(), rest_18, ctx_11)))));
                            }
                            case 4: {
                                const patternInput_16 = accLiterals.Value;
                                const ctx_12 = patternInput_16[1];
                                return append(patternInput_16[0], delay(() => {
                                    const patternInput_17 = getLinkAndTitle(toArray(link_6).join(''), MarkdownRangeModule_zero);
                                    return append(singleton_1(new MarkdownSpan(7, toArray(body_5).join(''), patternInput_17[0], patternInput_17[1], ctx_12.CurrentRange)), delay(() => parseChars(empty(), rest_19, ctx_12)));
                                }));
                            }
                            case 5: {
                                const patternInput_18 = accLiterals.Value;
                                const ctx_13 = patternInput_18[1];
                                return append(patternInput_18[0], delay(() => {
                                    const key_1 = isNullOrEmpty(link_8) ? (Array.from(body_6).join('')) : link_8;
                                    return append(singleton_1(new MarkdownSpan(8, toArray(body_6).join(''), original_1, key_1, ctx_13.CurrentRange)), delay(() => parseChars(empty(), rest_20, ctx_13)));
                                }));
                            }
                            case 6: {
                                const patternInput_19 = accLiterals.Value;
                                const ctx_14 = patternInput_19[1];
                                return append(patternInput_19[0], delay(() => append(singleton_1(f([ofSeq(parseChars(empty(), body_7, ctx_14)), ctx_14.CurrentRange])), delay(() => parseChars(empty(), rest_21, ctx_14)))));
                            }
                            case 7: {
                                return parseChars(ofArrayWithTail([";", "t", "l", "\u0026"], acc), rest_22, ctx);
                            }
                            case 8: {
                                return parseChars(ofArrayWithTail([";", "t", "g", "\u0026"], acc), rest_23, ctx);
                            }
                            case 9: {
                                return parseChars(cons(x_15, acc), xs_15, ctx);
                            }
                            case 10: {
                                return accLiterals.Value[0];
                            }
                        }
                    }
                }
            }
        }
    });
}

export function parseSpans(_arg1_, _arg1__1, ctx) {
    const _arg = [_arg1_, _arg1__1];
    const activePatternResult = StringPosition_$007CTrimBoth$007C(_arg[0], _arg[1]);
    const ctx_1 = new ParsingContext(ctx.Links, ctx.Newline, ctx.IsFirst, activePatternResult[1], ctx.ParseOptions);
    return ofSeq(parseChars(empty(), ofArray(activePatternResult[0].split("")), ctx_1));
}

export function trimSpaces(numSpaces_mut, s_mut) {
    trimSpaces:
    while (true) {
        const numSpaces = numSpaces_mut, s = s_mut;
        if (numSpaces <= 0) {
            return s;
        }
        else if (s.indexOf(" ") === 0) {
            numSpaces_mut = (numSpaces - 1);
            s_mut = substring(s, 1);
            continue trimSpaces;
        }
        else if (s.indexOf("\t") === 0) {
            numSpaces_mut = (numSpaces - 4);
            s_mut = substring(s, 1);
            continue trimSpaces;
        }
        else {
            return s;
        }
        break;
    }
}

export function $007CHeading$007C_$007C(lines) {
    let noHash, tupledArg_5, tupledArg_2;
    let pattern_matching_result, header, line1, line2, rest;
    if (!isEmpty(lines)) {
        let activePatternResult;
        const tupledArg = head(lines);
        activePatternResult = StringPosition_$007CTrimBoth$007C(tupledArg[0], tupledArg[1]);
        if (!isEmpty(tail(lines))) {
            let activePatternResult_1;
            const tupledArg_1 = head(tail(lines));
            activePatternResult_1 = StringPosition_$007CTrimEnd$007C(tupledArg_1[0], tupledArg_1[1]);
            if (((tupledArg_2 = ["=", MarkdownRangeModule_zero], StringPosition_$007CEqualsRepeated$007C_$007C(tupledArg_2[0], tupledArg_2[1], activePatternResult_1[0], activePatternResult_1[1]))) != null) {
                pattern_matching_result = 0;
                header = activePatternResult;
                line1 = head(lines);
                line2 = head(tail(lines));
                rest = tail(tail(lines));
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return [1, header, ofArray([line1, line2]), rest];
        }
        case 1: {
            let pattern_matching_result_1, header_1, line1_1, line2_1, rest_1;
            if (!isEmpty(lines)) {
                let activePatternResult_3;
                const tupledArg_3 = head(lines);
                activePatternResult_3 = StringPosition_$007CTrimBoth$007C(tupledArg_3[0], tupledArg_3[1]);
                if (!isEmpty(tail(lines))) {
                    let activePatternResult_4;
                    const tupledArg_4 = head(tail(lines));
                    activePatternResult_4 = StringPosition_$007CTrimEnd$007C(tupledArg_4[0], tupledArg_4[1]);
                    if (((tupledArg_5 = ["-", MarkdownRangeModule_zero], StringPosition_$007CEqualsRepeated$007C_$007C(tupledArg_5[0], tupledArg_5[1], activePatternResult_4[0], activePatternResult_4[1]))) != null) {
                        pattern_matching_result_1 = 0;
                        header_1 = activePatternResult_3;
                        line1_1 = head(lines);
                        line2_1 = head(tail(lines));
                        rest_1 = tail(tail(lines));
                    }
                    else {
                        pattern_matching_result_1 = 1;
                    }
                }
                else {
                    pattern_matching_result_1 = 1;
                }
            }
            else {
                pattern_matching_result_1 = 1;
            }
            switch (pattern_matching_result_1) {
                case 0: {
                    return [2, header_1, ofArray([line1_1, line2_1]), rest_1];
                }
                case 1: {
                    let pattern_matching_result_2, header_2, line1_2, ln_1, n_5, rest_2;
                    if (!isEmpty(lines)) {
                        let activePatternResult_6;
                        const tupledArg_6 = head(lines);
                        activePatternResult_6 = StringPosition_$007CStartsWithRepeated$007C_$007C("#", tupledArg_6[0], tupledArg_6[1]);
                        if (activePatternResult_6 != null) {
                            let activePatternResult_7;
                            const tupledArg_7 = activePatternResult_6[1];
                            activePatternResult_7 = StringPosition_$007CTrimBoth$007C(tupledArg_7[0], tupledArg_7[1]);
                            pattern_matching_result_2 = 0;
                            header_2 = activePatternResult_7[0];
                            line1_2 = head(lines);
                            ln_1 = activePatternResult_7[1];
                            n_5 = activePatternResult_6[0];
                            rest_2 = tail(lines);
                        }
                        else {
                            pattern_matching_result_2 = 1;
                        }
                    }
                    else {
                        pattern_matching_result_2 = 1;
                    }
                    switch (pattern_matching_result_2) {
                        case 0: {
                            return [n_5, [endsWith(header_2, "#") ? ((noHash = trimEnd(header_2, "#"), ((noHash.length > 0) && isWhiteSpace(getCharAtIndex(noHash, noHash.length - 1))) ? noHash : header_2)) : header_2, ln_1], singleton(line1_2), rest_2];
                        }
                        case 1: {
                            return void 0;
                        }
                    }
                }
            }
        }
    }
}

export function $007CYamlFrontmatter$007C_$007C(lines) {
    let pattern_matching_result, p, rest;
    if (!isEmpty(lines)) {
        if (head(lines)[0] === "---") {
            pattern_matching_result = 0;
            p = head(lines)[1];
            rest = tail(lines);
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            const yaml = takeWhile((tupledArg) => (tupledArg[0] !== "---"), rest);
            const yamlTextLines = map((tuple) => tuple[0], yaml);
            let rest_1;
            const _arg_2 = skipWhile((tupledArg_1) => (tupledArg_1[0] !== "---"), rest);
            let pattern_matching_result_1, t, l_2;
            if (!isEmpty(_arg_2)) {
                if (head(_arg_2)[0] === "---") {
                    pattern_matching_result_1 = 0;
                    t = tail(_arg_2);
                }
                else {
                    pattern_matching_result_1 = 1;
                    l_2 = _arg_2;
                }
            }
            else {
                pattern_matching_result_1 = 1;
                l_2 = _arg_2;
            }
            switch (pattern_matching_result_1) {
                case 0: {
                    rest_1 = t;
                    break;
                }
                case 1: {
                    rest_1 = l_2;
                    break;
                }
            }
            return [yamlTextLines, MarkdownRangeModule_mergeRanges(cons(p, map((tuple_1) => tuple_1[1], yaml))), rest_1];
        }
        case 1: {
            return void 0;
        }
    }
}

export function $007CHorizontalRule$007C_$007C(line, _n) {
    const loop = (arg_mut, i_mut) => {
        loop:
        while (true) {
            const arg = arg_mut, i = i_mut;
            const arg_1 = arg;
            const u = arg_1[2] | 0;
            const h = arg_1[0] | 0;
            const a = arg_1[1] | 0;
            if ((((h >= 3) ? true : (a >= 3)) ? true : (u >= 3)) && (i === line.length)) {
                return line[0];
            }
            else if (i === line.length) {
                return void 0;
            }
            else if (isWhiteSpace(line[i])) {
                arg_mut = arg_1;
                i_mut = (i + 1);
                continue loop;
            }
            else if (((line[i] === "-") && (a === 0)) && (u === 0)) {
                arg_mut = [h + 1, a, u];
                i_mut = (i + 1);
                continue loop;
            }
            else if (((line[i] === "*") && (h === 0)) && (u === 0)) {
                arg_mut = [h, a + 1, u];
                i_mut = (i + 1);
                continue loop;
            }
            else if (((line[i] === "_") && (a === 0)) && (h === 0)) {
                arg_mut = [h, a, u + 1];
                i_mut = (i + 1);
                continue loop;
            }
            else {
                return void 0;
            }
            break;
        }
    };
    return loop([0, 0, 0], 0);
}

export function $007CNestedCodeBlock$007C_$007C(lines) {
    let takenLines, rest, _numspaces;
    let pattern_matching_result, _numspaces_1, lines_2, rest_1, takenLines_1;
    const activePatternResult = Lines_$007CTakeCodeBlock$007C_$007C(lines);
    if (activePatternResult != null) {
        const activePatternResult_1 = Lines_$007CTrimBlank$007C(activePatternResult[1]);
        if ((takenLines = activePatternResult[1], (rest = activePatternResult[2], (_numspaces = (activePatternResult[0] | 0), !equals(activePatternResult_1, empty()))))) {
            pattern_matching_result = 0;
            _numspaces_1 = activePatternResult[0];
            lines_2 = activePatternResult_1;
            rest_1 = activePatternResult[2];
            takenLines_1 = activePatternResult[1];
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return [append_1(toList(delay(() => collect((matchValue) => {
                const l = matchValue[0];
                return singleton_1(isNullOrEmpty(l) ? "" : trimSpaces(4, l));
            }, lines_2))), singleton("")), takenLines_1, rest_1, "", ""];
        }
        case 1: {
            return void 0;
        }
    }
}

export function $007CFencedCodeBlock$007C_$007C(lines) {
    let indent, header, indent_1, header_1, indent_2, header_2;
    let pattern_matching_result, header_3, indent_3, lines_4, num_3, start_6, takenLine_3;
    if (!isEmpty(lines)) {
        let activePatternResult;
        const tupledArg = head(lines);
        activePatternResult = StringPosition_$007CStartsWithNTimesTrimIgnoreStartWhitespace$007C_$007C("~", tupledArg[0], tupledArg[1]);
        if (activePatternResult != null) {
            const activePatternResult_1 = $007CLet$007C("~", activePatternResult[0]);
            if ((indent = (activePatternResult[1] | 0), (header = activePatternResult[2], activePatternResult_1[1] > 2))) {
                pattern_matching_result = 0;
                header_3 = activePatternResult[2];
                indent_3 = activePatternResult[1];
                lines_4 = tail(lines);
                num_3 = activePatternResult_1[1];
                start_6 = activePatternResult_1[0];
                takenLine_3 = head(lines);
            }
            else {
                let activePatternResult_2;
                const tupledArg_1 = head(lines);
                activePatternResult_2 = StringPosition_$007CStartsWithNTimesTrimIgnoreStartWhitespace$007C_$007C("`", tupledArg_1[0], tupledArg_1[1]);
                if (activePatternResult_2 != null) {
                    const activePatternResult_3 = $007CLet$007C("`", activePatternResult_2[0]);
                    if ((indent_1 = (activePatternResult_2[1] | 0), (header_1 = activePatternResult_2[2], activePatternResult_3[1] > 2))) {
                        pattern_matching_result = 0;
                        header_3 = activePatternResult_2[2];
                        indent_3 = activePatternResult_2[1];
                        lines_4 = tail(lines);
                        num_3 = activePatternResult_3[1];
                        start_6 = activePatternResult_3[0];
                        takenLine_3 = head(lines);
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
            }
        }
        else {
            let activePatternResult_4;
            const tupledArg_2 = head(lines);
            activePatternResult_4 = StringPosition_$007CStartsWithNTimesTrimIgnoreStartWhitespace$007C_$007C("`", tupledArg_2[0], tupledArg_2[1]);
            if (activePatternResult_4 != null) {
                const activePatternResult_5 = $007CLet$007C("`", activePatternResult_4[0]);
                if ((indent_2 = (activePatternResult_4[1] | 0), (header_2 = activePatternResult_4[2], activePatternResult_5[1] > 2))) {
                    pattern_matching_result = 0;
                    header_3 = activePatternResult_4[2];
                    indent_3 = activePatternResult_4[1];
                    lines_4 = tail(lines);
                    num_3 = activePatternResult_5[1];
                    start_6 = activePatternResult_5[0];
                    takenLine_3 = head(lines);
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            let endStr = replicate(num_3, start_6);
            if (header_3.indexOf(start_6) >= 0) {
                return void 0;
            }
            else {
                const patternInput = List_partitionUntil((line) => {
                    const matchValue = singleton(line);
                    let pattern_matching_result_1, h_1, i_1, n_1;
                    if (!isEmpty(matchValue)) {
                        let activePatternResult_6;
                        const tupledArg_3 = head(matchValue);
                        activePatternResult_6 = StringPosition_$007CStartsWithNTimesTrimIgnoreStartWhitespace$007C_$007C(start_6, tupledArg_3[0], tupledArg_3[1]);
                        if (activePatternResult_6 != null) {
                            if (((activePatternResult_6[0] >= num_3) && (activePatternResult_6[1] < 4)) && isNullOrWhiteSpace(activePatternResult_6[2])) {
                                pattern_matching_result_1 = 0;
                                h_1 = activePatternResult_6[2];
                                i_1 = activePatternResult_6[1];
                                n_1 = activePatternResult_6[0];
                            }
                            else {
                                pattern_matching_result_1 = 1;
                            }
                        }
                        else {
                            pattern_matching_result_1 = 1;
                        }
                    }
                    else {
                        pattern_matching_result_1 = 1;
                    }
                    switch (pattern_matching_result_1) {
                        case 0: {
                            endStr = replicate(n_1, start_6);
                            return true;
                        }
                        case 1: {
                            return false;
                        }
                    }
                }, lines_4);
                const rest = patternInput[1];
                const codeLines = patternInput[0];
                const codeWithoutIndent = toList(delay(() => collect((matchValue_1) => {
                    let l;
                    return singleton_1((l = matchValue_1[0], ((l.length <= indent_3) && isNullOrWhiteSpace(l)) ? "" : (((l.length > indent_3) && isNullOrWhiteSpace(substring(l, 0, indent_3))) ? substring(l, indent_3, l.length - indent_3) : l.trimStart())));
                }, codeLines)));
                let patternInput_1;
                if (isNullOrWhiteSpace(header_3)) {
                    patternInput_1 = ["", ""];
                }
                else {
                    const matchValue_2 = tryFind((_arg) => true, split(header_3, [" "], null, 1));
                    if (matchValue_2 != null) {
                        const langString = matchValue_2;
                        const ignoredString = substring(header_3, header_3.indexOf(langString) + langString.length);
                        patternInput_1 = [langString, isNullOrWhiteSpace(ignoredString) ? "" : ignoredString];
                    }
                    else {
                        patternInput_1 = ["", ""];
                    }
                }
                let patternInput_2;
                if (!isEmpty(rest)) {
                    const tl = tail(rest);
                    const takenLine2 = head(rest);
                    const hd = head(rest)[0];
                    const idx = hd.indexOf(endStr) | 0;
                    if ((idx > -1) && ((idx + endStr.length) <= hd.length)) {
                        const _pre = substring(hd, 0, idx);
                        const after = substring(hd, idx + endStr.length);
                        patternInput_2 = [singleton(takenLine2), append_1(codeWithoutIndent, singleton("")), isNullOrWhiteSpace(after) ? tl : cons([after, head(rest)[1]], tl)];
                    }
                    else {
                        patternInput_2 = [singleton(takenLine2), append_1(codeWithoutIndent, singleton("")), tl];
                    }
                }
                else {
                    patternInput_2 = [empty(), codeWithoutIndent, rest];
                }
                return [patternInput_2[1], append_1(cons(takenLine_3, codeLines), patternInput_2[0]), patternInput_2[2], patternInput_1[0], patternInput_1[1]];
            }
        }
        case 1: {
            return void 0;
        }
    }
}

export function $007CSkipSomeNumbers$007C_$007C(input, _n) {
    const matchValue = ofSeq(input.split(""));
    let pattern_matching_result, x_1, xs_1;
    if (!isEmpty(matchValue)) {
        if (isDigit(head(matchValue))) {
            pattern_matching_result = 0;
            x_1 = head(matchValue);
            xs_1 = tail(matchValue);
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            const rest = List_partitionUntil((arg_1) => (!isDigit(arg_1)), xs_1)[1];
            return [input.length - length(rest), rest];
        }
        case 1: {
            return void 0;
        }
    }
}

export function $007CListStart$007C_$007C(_arg1_, _arg1__1) {
    let tupledArg, inputRecord, StartColumn;
    const _arg = [_arg1_, _arg1__1];
    const activePatternResult = StringPosition_$007CTrimStartAndCount$007C(_arg[0], _arg[1]);
    if (((tupledArg = activePatternResult[2], StringPosition_$007CStartsWithAny$007C_$007C(["+ ", "* ", "- "], tupledArg[0], tupledArg[1]))) != null) {
        const range = activePatternResult[2][1];
        const li = [substring(activePatternResult[2][0], 2), (inputRecord = (new FSharpRef(range)), (StartColumn = ((range.StartColumn + 2) | 0), new MarkdownRange(inputRecord.contents.StartLine, StartColumn, inputRecord.contents.EndLine, inputRecord.contents.EndColumn)))];
        const startIndent2 = StringPosition_$007CTrimStartAndCount$007C(li[0], li[1])[0] | 0;
        return [new MarkdownListKind(1), activePatternResult[0], (activePatternResult[0] + 2) + ((startIndent2 >= 5) ? 1 : startIndent2), li];
    }
    else {
        let pattern_matching_result, _spaces_1, item_1, skipNumCount, startIndent_1;
        const activePatternResult_3 = StringPosition_$007CTrimStartAndCount$007C(_arg[0], _arg[1]);
        let activePatternResult_4;
        const tupledArg_1 = activePatternResult_3[2];
        activePatternResult_4 = $007CSkipSomeNumbers$007C_$007C(tupledArg_1[0], tupledArg_1[1]);
        if (activePatternResult_4 != null) {
            if (!isEmpty(activePatternResult_4[1])) {
                if (head(activePatternResult_4[1]) === ".") {
                    if (!isEmpty(tail(activePatternResult_4[1]))) {
                        if (head(tail(activePatternResult_4[1])) === " ") {
                            const activePatternResult_5 = List_$007CAsString$007C(tail(tail(activePatternResult_4[1])));
                            pattern_matching_result = 0;
                            _spaces_1 = activePatternResult_3[1];
                            item_1 = activePatternResult_5;
                            skipNumCount = activePatternResult_4[0];
                            startIndent_1 = activePatternResult_3[0];
                        }
                        else {
                            pattern_matching_result = 1;
                        }
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
        switch (pattern_matching_result) {
            case 0: {
                const patternInput = [item_1, MarkdownRangeModule_zero];
                const startIndent2_1 = StringPosition_$007CTrimStartAndCount$007C(patternInput[0], patternInput[1])[0] | 0;
                return [new MarkdownListKind(0), startIndent_1, ((startIndent_1 + 2) + skipNumCount) + ((startIndent2_1 >= 5) ? 1 : startIndent2_1), [item_1, MarkdownRangeModule_zero]];
            }
            case 1: {
                return void 0;
            }
        }
    }
}

export function $007CLinesUntilListOrWhite$007C(lines) {
    return List_partitionUntil((_arg) => {
        let pattern_matching_result;
        if ($007CListStart$007C_$007C(_arg[0], _arg[1]) != null) {
            pattern_matching_result = 0;
        }
        else if (StringPosition_$007CWhiteSpace$007C_$007C(_arg[0], _arg[1]) != null) {
            pattern_matching_result = 0;
        }
        else {
            pattern_matching_result = 1;
        }
        switch (pattern_matching_result) {
            case 0: {
                return true;
            }
            case 1: {
                return false;
            }
        }
    }, lines);
}

export function $007CLinesUntilListOrUnindented$007C(lines) {
    return List_partitionUntilLookahead((_arg) => {
        let tupledArg, tupledArg_1, tupledArg_2, tupledArg_3;
        let pattern_matching_result;
        if (!isEmpty(_arg)) {
            if (((tupledArg = head(_arg), $007CListStart$007C_$007C(tupledArg[0], tupledArg[1]))) != null) {
                pattern_matching_result = 0;
            }
            else if (((tupledArg_1 = head(_arg), StringPosition_$007CUnindented$007C_$007C(tupledArg_1[0], tupledArg_1[1]))) != null) {
                pattern_matching_result = 0;
            }
            else if (((tupledArg_2 = head(_arg), StringPosition_$007CWhiteSpace$007C_$007C(tupledArg_2[0], tupledArg_2[1]))) != null) {
                if (!isEmpty(tail(_arg))) {
                    if (((tupledArg_3 = head(tail(_arg)), StringPosition_$007CWhiteSpace$007C_$007C(tupledArg_3[0], tupledArg_3[1]))) != null) {
                        pattern_matching_result = 0;
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
        switch (pattern_matching_result) {
            case 0: {
                return true;
            }
            case 1: {
                return false;
            }
        }
    }, lines);
}

export function $007CListItem$007C_$007C(prevSimple, lines) {
    let activePatternResult_3, matchValue, tupledArg_1, tupledArg_2, tupledArg_3, tupledArg_4, tupledArg_5, tupledArg_6, tupledArg_7;
    let pattern_matching_result, continued, endIndent, item, kind, more, next, rest, startIndent, takenLine;
    if (!isEmpty(lines)) {
        let activePatternResult;
        const tupledArg = head(lines);
        activePatternResult = $007CListStart$007C_$007C(tupledArg[0], tupledArg[1]);
        if (activePatternResult != null) {
            const activePatternResult_1 = $007CLinesUntilListOrWhite$007C(tail(lines));
            const activePatternResult_2 = $007CLinesUntilListOrUnindented$007C(activePatternResult_1[1]);
            pattern_matching_result = 0;
            continued = activePatternResult_1[0];
            endIndent = activePatternResult[2];
            item = activePatternResult[3];
            kind = activePatternResult[0];
            more = activePatternResult_2[0];
            next = activePatternResult_1[1];
            rest = activePatternResult_2[1];
            startIndent = activePatternResult[1];
            takenLine = head(lines);
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return [startIndent, [(activePatternResult_3 = StringPosition_$007CTrimStartAndCount$007C(item[0], item[1]), (activePatternResult_3[1] >= 4) ? false : ((matchValue = [next, rest], (!isEmpty(matchValue[0])) ? ((((tupledArg_1 = head(matchValue[0]), StringPosition_$007CWhiteSpace$007C_$007C(tupledArg_1[0], tupledArg_1[1]))) != null) ? ((!isEmpty(matchValue[1])) ? ((((tupledArg_2 = head(matchValue[1]), $007CListStart$007C_$007C(tupledArg_2[0], tupledArg_2[1]))) != null) ? false : (isEmpty(matchValue[0]) ? true : ((((tupledArg_3 = head(matchValue[0]), $007CListStart$007C_$007C(tupledArg_3[0], tupledArg_3[1]))) != null) ? true : ((((tupledArg_4 = head(matchValue[0]), StringPosition_$007CWhiteSpace$007C_$007C(tupledArg_4[0], tupledArg_4[1]))) != null) ? (isEmpty(tail(matchValue[0])) ? true : ((!isEmpty(matchValue[0])) ? ((((tupledArg_5 = head(matchValue[0]), StringPosition_$007CWhiteSpace$007C_$007C(tupledArg_5[0], tupledArg_5[1]))) != null) ? ((!isEmpty(tail(matchValue[0]))) ? ((((tupledArg_6 = head(tail(matchValue[0])), StringPosition_$007CWhiteSpace$007C_$007C(tupledArg_6[0], tupledArg_6[1]))) != null) ? true : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple))) : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple))) : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple))) : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple)))) : ((!isEmpty(matchValue[0])) ? ((((tupledArg_5 = head(matchValue[0]), StringPosition_$007CWhiteSpace$007C_$007C(tupledArg_5[0], tupledArg_5[1]))) != null) ? ((!isEmpty(tail(matchValue[0]))) ? ((((tupledArg_6 = head(tail(matchValue[0])), StringPosition_$007CWhiteSpace$007C_$007C(tupledArg_6[0], tupledArg_6[1]))) != null) ? true : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple))) : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple))) : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple))) : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple))))))) : (isEmpty(matchValue[0]) ? true : ((((tupledArg_3 = head(matchValue[0]), $007CListStart$007C_$007C(tupledArg_3[0], tupledArg_3[1]))) != null) ? true : ((((tupledArg_4 = head(matchValue[0]), StringPosition_$007CWhiteSpace$007C_$007C(tupledArg_4[0], tupledArg_4[1]))) != null) ? (isEmpty(tail(matchValue[0])) ? true : ((!isEmpty(matchValue[0])) ? ((((tupledArg_5 = head(matchValue[0]), StringPosition_$007CWhiteSpace$007C_$007C(tupledArg_5[0], tupledArg_5[1]))) != null) ? ((!isEmpty(tail(matchValue[0]))) ? ((((tupledArg_6 = head(tail(matchValue[0])), StringPosition_$007CWhiteSpace$007C_$007C(tupledArg_6[0], tupledArg_6[1]))) != null) ? true : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple))) : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple))) : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple))) : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple)))) : ((!isEmpty(matchValue[0])) ? ((((tupledArg_5 = head(matchValue[0]), StringPosition_$007CWhiteSpace$007C_$007C(tupledArg_5[0], tupledArg_5[1]))) != null) ? ((!isEmpty(tail(matchValue[0]))) ? ((((tupledArg_6 = head(tail(matchValue[0])), StringPosition_$007CWhiteSpace$007C_$007C(tupledArg_6[0], tupledArg_6[1]))) != null) ? true : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple))) : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple))) : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple))) : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple))))))) : (isEmpty(matchValue[0]) ? true : ((((tupledArg_3 = head(matchValue[0]), $007CListStart$007C_$007C(tupledArg_3[0], tupledArg_3[1]))) != null) ? true : ((((tupledArg_4 = head(matchValue[0]), StringPosition_$007CWhiteSpace$007C_$007C(tupledArg_4[0], tupledArg_4[1]))) != null) ? (isEmpty(tail(matchValue[0])) ? true : ((!isEmpty(matchValue[0])) ? ((((tupledArg_5 = head(matchValue[0]), StringPosition_$007CWhiteSpace$007C_$007C(tupledArg_5[0], tupledArg_5[1]))) != null) ? ((!isEmpty(tail(matchValue[0]))) ? ((((tupledArg_6 = head(tail(matchValue[0])), StringPosition_$007CWhiteSpace$007C_$007C(tupledArg_6[0], tupledArg_6[1]))) != null) ? true : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple))) : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple))) : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple))) : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple)))) : ((!isEmpty(matchValue[0])) ? ((((tupledArg_5 = head(matchValue[0]), StringPosition_$007CWhiteSpace$007C_$007C(tupledArg_5[0], tupledArg_5[1]))) != null) ? ((!isEmpty(tail(matchValue[0]))) ? ((((tupledArg_6 = head(tail(matchValue[0])), StringPosition_$007CWhiteSpace$007C_$007C(tupledArg_6[0], tupledArg_6[1]))) != null) ? true : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple))) : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple))) : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple))) : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple))))))) : (isEmpty(matchValue[0]) ? true : ((((tupledArg_3 = head(matchValue[0]), $007CListStart$007C_$007C(tupledArg_3[0], tupledArg_3[1]))) != null) ? true : ((((tupledArg_4 = head(matchValue[0]), StringPosition_$007CWhiteSpace$007C_$007C(tupledArg_4[0], tupledArg_4[1]))) != null) ? (isEmpty(tail(matchValue[0])) ? true : ((!isEmpty(matchValue[0])) ? ((((tupledArg_5 = head(matchValue[0]), StringPosition_$007CWhiteSpace$007C_$007C(tupledArg_5[0], tupledArg_5[1]))) != null) ? ((!isEmpty(tail(matchValue[0]))) ? ((((tupledArg_6 = head(tail(matchValue[0])), StringPosition_$007CWhiteSpace$007C_$007C(tupledArg_6[0], tupledArg_6[1]))) != null) ? true : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple))) : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple))) : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple))) : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple)))) : ((!isEmpty(matchValue[0])) ? ((((tupledArg_5 = head(matchValue[0]), StringPosition_$007CWhiteSpace$007C_$007C(tupledArg_5[0], tupledArg_5[1]))) != null) ? ((!isEmpty(tail(matchValue[0]))) ? ((((tupledArg_6 = head(tail(matchValue[0])), StringPosition_$007CWhiteSpace$007C_$007C(tupledArg_6[0], tupledArg_6[1]))) != null) ? true : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple))) : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple))) : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple))) : ((!isEmpty(matchValue[1])) && ((((tupledArg_7 = head(matchValue[1]), StringPosition_$007CUnindented$007C_$007C(tupledArg_7[0], tupledArg_7[1]))) != null) && prevSimple))))))))), kind, toList(delay(() => append(singleton_1(item), delay(() => append(collect((matchValue_1) => singleton_1([matchValue_1[0].trim(), matchValue_1[1]]), continued), delay(() => collect((matchValue_2) => {
                let inputRecord, StartColumn;
                const n_2 = matchValue_2[1];
                const line_1 = matchValue_2[0];
                const trimmed = trimSpaces(endIndent, line_1);
                return singleton_1([trimmed, (inputRecord = (new FSharpRef(n_2)), (StartColumn = (((n_2.StartColumn + line_1.length) - trimmed.length) | 0), new MarkdownRange(inputRecord.contents.StartLine, StartColumn, inputRecord.contents.EndLine, inputRecord.contents.EndColumn)))]);
            }, more)))))))], append_1(cons(takenLine, continued), more), rest];
        }
        case 1: {
            return void 0;
        }
    }
}

export function $007CListItems$007C_$007C(prevSimple, lines) {
    let tupledArg;
    const activePatternResult = $007CListItem$007C_$007C(prevSimple, lines);
    if (activePatternResult != null) {
        const indent = activePatternResult[0] | 0;
        const info = activePatternResult[1];
        const nextSimple = activePatternResult[1][0];
        const rest = activePatternResult[3];
        const takenLines = activePatternResult[2];
        let pattern_matching_result, takenLine2, items, rest_1, takenLines2;
        if (!isEmpty(rest)) {
            if (((tupledArg = head(rest), $007CHorizontalRule$007C_$007C(tupledArg[0], tupledArg[1]))) != null) {
                pattern_matching_result = 0;
                takenLine2 = head(rest);
            }
            else {
                const activePatternResult_2 = $007CListItems$007C_$007C(nextSimple, rest);
                if (activePatternResult_2 != null) {
                    pattern_matching_result = 1;
                    items = activePatternResult_2[0];
                    rest_1 = activePatternResult_2[2];
                    takenLines2 = activePatternResult_2[1];
                }
                else {
                    pattern_matching_result = 2;
                }
            }
        }
        else {
            const activePatternResult_3 = $007CListItems$007C_$007C(nextSimple, rest);
            if (activePatternResult_3 != null) {
                pattern_matching_result = 1;
                items = activePatternResult_3[0];
                rest_1 = activePatternResult_3[2];
                takenLines2 = activePatternResult_3[1];
            }
            else {
                pattern_matching_result = 2;
            }
        }
        switch (pattern_matching_result) {
            case 0: {
                return [singleton([indent, info]), append_1(takenLines, singleton(takenLine2)), rest];
            }
            case 1: {
                return [cons([indent, info], items), append_1(takenLines, takenLines2), rest_1];
            }
            case 2: {
                return [singleton([indent, info]), takenLines, rest];
            }
        }
    }
    else {
        return void 0;
    }
}

export function pipeTableFindSplits(delim, line) {
    let _x;
    const cLstToStr = (x) => join("", toArray(x));
    const ptfs = (delim_1_mut, line_1_mut) => {
        let loop, str_1;
        ptfs:
        while (true) {
            const delim_1 = delim_1_mut, line_1 = line_1_mut;
            let pattern_matching_result, _body, rest_1, _body_1, rest_2, _body_2, _e, _s, rest_3, _body_3, _e_1, _s_1, rest_4, rest_5, x_5, rest_6;
            const activePatternResult = $007CDelimitedLatexDisplayMath$007C_$007C(ofArray(["$", "$"]), line_1);
            if (activePatternResult != null) {
                pattern_matching_result = 0;
                _body = activePatternResult[0];
                rest_1 = activePatternResult[1];
            }
            else {
                const activePatternResult_1 = $007CDelimitedLatexInlineMath$007C_$007C(singleton("$"), line_1);
                if (activePatternResult_1 != null) {
                    pattern_matching_result = 1;
                    _body_1 = activePatternResult_1[0];
                    rest_2 = activePatternResult_1[1];
                }
                else {
                    let activePatternResult_2;
                    const startl = ofArray(["`", " "]);
                    const endl = ofArray([" ", "`"]);
                    const input = line_1;
                    if ((loop = ((start_1_mut, list_1_1_mut) => {
                        loop:
                        while (true) {
                            const start_1 = start_1_mut, list_1_1 = list_1_1_mut;
                            const matchValue = [start_1, list_1_1];
                            let pattern_matching_result_1, x_1, xs_1, y_1, ys_1;
                            if (isEmpty(matchValue[0])) {
                                pattern_matching_result_1 = 1;
                            }
                            else if (!isEmpty(matchValue[1])) {
                                if (head(matchValue[0]) === head(matchValue[1])) {
                                    pattern_matching_result_1 = 0;
                                    x_1 = head(matchValue[0]);
                                    xs_1 = tail(matchValue[0]);
                                    y_1 = head(matchValue[1]);
                                    ys_1 = tail(matchValue[1]);
                                }
                                else {
                                    pattern_matching_result_1 = 2;
                                }
                            }
                            else {
                                pattern_matching_result_1 = 2;
                            }
                            switch (pattern_matching_result_1) {
                                case 0: {
                                    start_1_mut = xs_1;
                                    list_1_1_mut = ys_1;
                                    continue loop;
                                }
                                case 1: {
                                    return true;
                                }
                                case 2: {
                                    return false;
                                }
                            }
                            break;
                        }
                    }), loop(startl, input))) {
                        const matchValue_1 = List_partitionUntilEquals(endl, skip(length(startl), input));
                        if (matchValue_1 == null) {
                            activePatternResult_2 = (void 0);
                        }
                        else {
                            const post = matchValue_1[1];
                            activePatternResult_2 = [matchValue_1[0], skip(length(endl), post), length(startl), length(endl)];
                        }
                    }
                    else {
                        activePatternResult_2 = (void 0);
                    }
                    if (activePatternResult_2 != null) {
                        pattern_matching_result = 2;
                        _body_2 = activePatternResult_2[0];
                        _e = activePatternResult_2[3];
                        _s = activePatternResult_2[2];
                        rest_3 = activePatternResult_2[1];
                    }
                    else {
                        let activePatternResult_3;
                        const str = "`";
                        const input_1 = line_1;
                        const strs = List_partitionWhile((i) => (i === str), input_1)[0];
                        activePatternResult_3 = ((!isEmpty(strs)) ? ((str_1 = initialize(length(strs), (_arg) => str), (input_2) => {
                            let loop_1;
                            const startl_1 = str_1;
                            const endl_1 = str_1;
                            const input_3 = input_2;
                            if ((loop_1 = ((start_1_1_mut, list_1_2_mut) => {
                                loop_1:
                                while (true) {
                                    const start_1_1 = start_1_1_mut, list_1_2 = list_1_2_mut;
                                    const matchValue_2 = [start_1_1, list_1_2];
                                    let pattern_matching_result_2, x_1_1, xs_1_1, y_1_1, ys_1_1;
                                    if (isEmpty(matchValue_2[0])) {
                                        pattern_matching_result_2 = 1;
                                    }
                                    else if (!isEmpty(matchValue_2[1])) {
                                        if (head(matchValue_2[0]) === head(matchValue_2[1])) {
                                            pattern_matching_result_2 = 0;
                                            x_1_1 = head(matchValue_2[0]);
                                            xs_1_1 = tail(matchValue_2[0]);
                                            y_1_1 = head(matchValue_2[1]);
                                            ys_1_1 = tail(matchValue_2[1]);
                                        }
                                        else {
                                            pattern_matching_result_2 = 2;
                                        }
                                    }
                                    else {
                                        pattern_matching_result_2 = 2;
                                    }
                                    switch (pattern_matching_result_2) {
                                        case 0: {
                                            start_1_1_mut = xs_1_1;
                                            list_1_2_mut = ys_1_1;
                                            continue loop_1;
                                        }
                                        case 1: {
                                            return true;
                                        }
                                        case 2: {
                                            return false;
                                        }
                                    }
                                    break;
                                }
                            }), loop_1(startl_1, input_3))) {
                                const matchValue_3 = List_partitionUntilEquals(endl_1, skip(length(startl_1), input_3));
                                if (matchValue_3 == null) {
                                    return void 0;
                                }
                                else {
                                    const post_1 = matchValue_3[1];
                                    return [matchValue_3[0], skip(length(endl_1), post_1), length(startl_1), length(endl_1)];
                                }
                            }
                            else {
                                return void 0;
                            }
                        }))(input_1) : (void 0));
                        if (activePatternResult_3 != null) {
                            pattern_matching_result = 3;
                            _body_3 = activePatternResult_3[0];
                            _e_1 = activePatternResult_3[3];
                            _s_1 = activePatternResult_3[2];
                            rest_4 = activePatternResult_3[1];
                        }
                        else if (isEmpty(line_1)) {
                            pattern_matching_result = 6;
                        }
                        else if (delim_1.some((y_3) => (head(line_1) === y_3))) {
                            pattern_matching_result = 4;
                            rest_5 = tail(line_1);
                            x_5 = head(line_1);
                        }
                        else if (head(line_1) === "\\") {
                            if (!isEmpty(tail(line_1))) {
                                pattern_matching_result = 5;
                                rest_6 = tail(tail(line_1));
                            }
                            else {
                                pattern_matching_result = 5;
                                rest_6 = tail(line_1);
                            }
                        }
                        else {
                            pattern_matching_result = 5;
                            rest_6 = tail(line_1);
                        }
                    }
                }
            }
            switch (pattern_matching_result) {
                case 0: {
                    delim_1_mut = delim_1;
                    line_1_mut = rest_1;
                    continue ptfs;
                }
                case 1: {
                    delim_1_mut = delim_1;
                    line_1_mut = rest_2;
                    continue ptfs;
                }
                case 2: {
                    delim_1_mut = delim_1;
                    line_1_mut = rest_3;
                    continue ptfs;
                }
                case 3: {
                    delim_1_mut = delim_1;
                    line_1_mut = rest_4;
                    continue ptfs;
                }
                case 4: {
                    return rest_5;
                }
                case 5: {
                    delim_1_mut = delim_1;
                    line_1_mut = rest_6;
                    continue ptfs;
                }
                case 6: {
                    return void 0;
                }
            }
            break;
        }
    };
    const rest_7 = ptfs(delim, line);
    if (rest_7 != null) {
        if ((_x = rest_7, equals(line, empty()))) {
            const _x_1 = rest_7;
            return singleton("");
        }
        else {
            const x_6 = rest_7;
            return cons(cLstToStr(toList(take((length(line) - length(x_6)) - 1, line))), pipeTableFindSplits(delim, x_6));
        }
    }
    else {
        return singleton(cLstToStr(line));
    }
}

export function $007CTableCellSeparator$007C_$007C(_arg1_, _arg1__1) {
    let tupledArg_8, tupledArg_6, tupledArg_7, tupledArg_3, tupledArg_4, tupledArg_1, tupledArg_2;
    const _arg = [_arg1_, _arg1__1];
    let pattern_matching_result;
    let activePatternResult;
    const tupledArg = [":", ":"];
    activePatternResult = StringPosition_$007CStartsAndEndsWith$007C_$007C(tupledArg[0], tupledArg[1], _arg[0], _arg[1]);
    if (activePatternResult != null) {
        if (((tupledArg_1 = ["-", MarkdownRangeModule_zero], (tupledArg_2 = activePatternResult, StringPosition_$007CEqualsRepeated$007C_$007C(tupledArg_1[0], tupledArg_1[1], tupledArg_2[0], tupledArg_2[1])))) != null) {
            pattern_matching_result = 0;
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return new MarkdownColumnAlignment(2);
        }
        case 1: {
            let pattern_matching_result_1;
            const activePatternResult_2 = StringPosition_$007CStartsWith$007C_$007C(":", _arg[0], _arg[1]);
            if (activePatternResult_2 != null) {
                if (((tupledArg_3 = ["-", MarkdownRangeModule_zero], (tupledArg_4 = activePatternResult_2, StringPosition_$007CEqualsRepeated$007C_$007C(tupledArg_3[0], tupledArg_3[1], tupledArg_4[0], tupledArg_4[1])))) != null) {
                    pattern_matching_result_1 = 0;
                }
                else {
                    pattern_matching_result_1 = 1;
                }
            }
            else {
                pattern_matching_result_1 = 1;
            }
            switch (pattern_matching_result_1) {
                case 0: {
                    return new MarkdownColumnAlignment(0);
                }
                case 1: {
                    let pattern_matching_result_2;
                    let activePatternResult_4;
                    const tupledArg_5 = ["", ":"];
                    activePatternResult_4 = StringPosition_$007CStartsAndEndsWith$007C_$007C(tupledArg_5[0], tupledArg_5[1], _arg[0], _arg[1]);
                    if (activePatternResult_4 != null) {
                        if (((tupledArg_6 = ["-", MarkdownRangeModule_zero], (tupledArg_7 = activePatternResult_4, StringPosition_$007CEqualsRepeated$007C_$007C(tupledArg_6[0], tupledArg_6[1], tupledArg_7[0], tupledArg_7[1])))) != null) {
                            pattern_matching_result_2 = 0;
                        }
                        else {
                            pattern_matching_result_2 = 1;
                        }
                    }
                    else {
                        pattern_matching_result_2 = 1;
                    }
                    switch (pattern_matching_result_2) {
                        case 0: {
                            return new MarkdownColumnAlignment(1);
                        }
                        case 1: {
                            if (((tupledArg_8 = ["-", MarkdownRangeModule_zero], StringPosition_$007CEqualsRepeated$007C_$007C(tupledArg_8[0], tupledArg_8[1], _arg[0], _arg[1]))) != null) {
                                return new MarkdownColumnAlignment(3);
                            }
                            else {
                                return void 0;
                            }
                        }
                    }
                }
            }
        }
    }
}

export function $007CPipeTableRow$007C_$007C(size, delimiters, line, n) {
    const parts = map_1((s) => [s.trim(), n], toArray(pipeTableFindSplits(delimiters, ofArray(line.split("")))));
    const n_1 = parts.length | 0;
    const m = ((size == null) ? 1 : value_14(size)) | 0;
    const x = ((isNullOrEmpty(parts[0][0]) && (n_1 > m)) ? 1 : 0) | 0;
    const y = ((isNullOrEmpty(parts[n_1 - 1][0]) && ((n_1 - x) > m)) ? (n_1 - 2) : (n_1 - 1)) | 0;
    if ((n_1 === 1) ? true : ((size != null) && (((y - x) + 1) !== m))) {
        return void 0;
    }
    else {
        return ofArray(parts.slice(x, y + 1));
    }
}

export function $007CPipeSeparatorRow$007C_$007C(size, _arg1_, _arg1__1) {
    const _arg = [_arg1_, _arg1__1];
    const activePatternResult = $007CPipeTableRow$007C_$007C(size, ["|", "+"], _arg[0], _arg[1]);
    if (activePatternResult != null) {
        const parts = activePatternResult;
        const alignments = choose((tupledArg) => $007CTableCellSeparator$007C_$007C(tupledArg[0], tupledArg[1]), parts);
        if (length(parts) !== length(alignments)) {
            return void 0;
        }
        else {
            return alignments;
        }
    }
    else {
        return void 0;
    }
}

export function $007CPipeTableBlock$007C_$007C(input) {
    const getTableRows = (size_mut, acc_mut, takenLinesAcc_mut, lines_mut) => {
        getTableRows:
        while (true) {
            const size = size_mut, acc = acc_mut, takenLinesAcc = takenLinesAcc_mut, lines = lines_mut;
            let pattern_matching_result, columns, rest, takenLine, rest_1;
            if (!isEmpty(lines)) {
                let activePatternResult;
                const tupledArg = head(lines);
                activePatternResult = $007CPipeTableRow$007C_$007C(size, ["|"], tupledArg[0], tupledArg[1]);
                if (activePatternResult != null) {
                    pattern_matching_result = 0;
                    columns = activePatternResult;
                    rest = tail(lines);
                    takenLine = head(lines);
                }
                else {
                    pattern_matching_result = 1;
                    rest_1 = lines;
                }
            }
            else {
                pattern_matching_result = 1;
                rest_1 = lines;
            }
            switch (pattern_matching_result) {
                case 0: {
                    size_mut = size;
                    acc_mut = cons(map(singleton, columns), acc);
                    takenLinesAcc_mut = cons(takenLine, takenLinesAcc);
                    lines_mut = rest;
                    continue getTableRows;
                }
                case 1: {
                    return [reverse(acc), reverse(takenLinesAcc), rest_1];
                }
            }
            break;
        }
    };
    let pattern_matching_result_1, alignments, rest_2, takenLine_1, headers, rest_3, takenLine_2;
    if (!isEmpty(input)) {
        let activePatternResult_1;
        const tupledArg_1 = head(input);
        activePatternResult_1 = $007CPipeSeparatorRow$007C_$007C(void 0, tupledArg_1[0], tupledArg_1[1]);
        if (activePatternResult_1 != null) {
            pattern_matching_result_1 = 0;
            alignments = activePatternResult_1;
            rest_2 = tail(input);
            takenLine_1 = head(input);
        }
        else {
            let activePatternResult_2;
            const tupledArg_2 = head(input);
            activePatternResult_2 = $007CPipeTableRow$007C_$007C(void 0, ["|"], tupledArg_2[0], tupledArg_2[1]);
            if (activePatternResult_2 != null) {
                pattern_matching_result_1 = 1;
                headers = activePatternResult_2;
                rest_3 = tail(input);
                takenLine_2 = head(input);
            }
            else {
                pattern_matching_result_1 = 2;
            }
        }
    }
    else {
        pattern_matching_result_1 = 2;
    }
    switch (pattern_matching_result_1) {
        case 0: {
            const patternInput = getTableRows(length(alignments), empty(), empty(), rest_2);
            return [[void 0, alignments, patternInput[0]], cons(takenLine_1, patternInput[1]), patternInput[2]];
        }
        case 1: {
            let pattern_matching_result_2, alignments_1, rest_4, takenLine2;
            if (!isEmpty(rest_3)) {
                let activePatternResult_3;
                const tupledArg_3 = head(rest_3);
                activePatternResult_3 = $007CPipeSeparatorRow$007C_$007C(length(headers), tupledArg_3[0], tupledArg_3[1]);
                if (activePatternResult_3 != null) {
                    pattern_matching_result_2 = 0;
                    alignments_1 = activePatternResult_3;
                    rest_4 = tail(rest_3);
                    takenLine2 = head(rest_3);
                }
                else {
                    pattern_matching_result_2 = 1;
                }
            }
            else {
                pattern_matching_result_2 = 1;
            }
            switch (pattern_matching_result_2) {
                case 0: {
                    const patternInput_1 = getTableRows(length(headers), empty(), empty(), rest_4);
                    return [[map(singleton, headers), alignments_1, patternInput_1[0]], ofArrayWithTail([takenLine_2, takenLine2], patternInput_1[1]), patternInput_1[2]];
                }
                case 1: {
                    return void 0;
                }
            }
        }
        case 2: {
            return void 0;
        }
    }
}

export function $007CEmacsTableLine$007C_$007C(grid, c, check, line, _n) {
    let p;
    if (grid != null) {
        p = value_14(grid);
    }
    else {
        const array = toArray_1(rangeDouble(0, 1, line.length - 1));
        p = array.filter((i) => (line[i] === c));
    }
    const n = (p.length - 1) | 0;
    if (((n < 2) ? true : (line.length <= p[n])) ? true : p.some((i_1) => (line[i_1] !== c))) {
        return void 0;
    }
    else {
        const parts = map((i_2) => {
            const rng = new MarkdownRange(n, 0, n, (p[i_2] - p[i_2 - 1]) - 1);
            return [substring(line, p[i_2 - 1] + 1, (p[i_2] - p[i_2 - 1]) - 1), rng];
        }, toList(rangeDouble(1, 1, n)));
        if (forAll_1(check, parts)) {
            return [p, parts];
        }
        else {
            return void 0;
        }
    }
}

export function $007CEmacsTableBlock$007C_$007C(lines) {
    let pattern_matching_result, grid_1, parts, rest, takenLine;
    if (!isEmpty(lines)) {
        let activePatternResult;
        const tupledArg_4 = head(lines);
        activePatternResult = $007CEmacsTableLine$007C_$007C(void 0, "+", (arg_1) => {
            let tupledArg_1;
            return ((tupledArg_1 = arg_1, $007CTableCellSeparator$007C_$007C(tupledArg_1[0], tupledArg_1[1]))) != null;
        }, tupledArg_4[0], tupledArg_4[1]);
        if (activePatternResult != null) {
            pattern_matching_result = 0;
            grid_1 = activePatternResult[0];
            parts = activePatternResult[1];
            rest = tail(lines);
            takenLine = head(lines);
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            const alignments = choose((tupledArg_5) => $007CTableCellSeparator$007C_$007C(tupledArg_5[0], tupledArg_5[1]), parts);
            const emptyCur = replicate_1(grid_1.length - 1, empty());
            const loop = (flag_mut, takenLines2_mut, headers_mut, prevRows_mut, cur_mut, lines_1_mut) => {
                let tupledArg_7, tupledArg_8;
                loop:
                while (true) {
                    const flag = flag_mut, takenLines2 = takenLines2_mut, headers = headers_mut, prevRows = prevRows_mut, cur = cur_mut, lines_1 = lines_1_mut;
                    let pattern_matching_result_1, others_1, parts_1, takenLine2_1, others_2, takenLine2_2, others_3, takenLine2_3;
                    if (!isEmpty(lines_1)) {
                        let activePatternResult_1;
                        const tupledArg_6 = head(lines_1);
                        activePatternResult_1 = $007CEmacsTableLine$007C_$007C(grid_1, "|", (tupledArg_3) => true, tupledArg_6[0], tupledArg_6[1]);
                        if (activePatternResult_1 != null) {
                            pattern_matching_result_1 = 0;
                            others_1 = tail(lines_1);
                            parts_1 = activePatternResult_1[1];
                            takenLine2_1 = head(lines_1);
                        }
                        else if (((tupledArg_7 = head(lines_1), $007CEmacsTableLine$007C_$007C(grid_1, "+", (arg) => {
                            let tupledArg;
                            return ((tupledArg = arg, StringPosition_$007CEqualsRepeated$007C_$007C("-", MarkdownRangeModule_zero, tupledArg[0], tupledArg[1]))) != null;
                        }, tupledArg_7[0], tupledArg_7[1]))) != null) {
                            pattern_matching_result_1 = 1;
                            others_2 = tail(lines_1);
                            takenLine2_2 = head(lines_1);
                        }
                        else if (((tupledArg_8 = head(lines_1), $007CEmacsTableLine$007C_$007C(grid_1, "+", (arg_2) => {
                            let tupledArg_2;
                            return ((tupledArg_2 = arg_2, StringPosition_$007CEqualsRepeated$007C_$007C("=", MarkdownRangeModule_zero, tupledArg_2[0], tupledArg_2[1]))) != null;
                        }, tupledArg_8[0], tupledArg_8[1]))) != null) {
                            if (headers == null) {
                                pattern_matching_result_1 = 2;
                                others_3 = tail(lines_1);
                                takenLine2_3 = head(lines_1);
                            }
                            else {
                                pattern_matching_result_1 = 3;
                            }
                        }
                        else {
                            pattern_matching_result_1 = 3;
                        }
                    }
                    else {
                        pattern_matching_result_1 = 3;
                    }
                    switch (pattern_matching_result_1) {
                        case 0: {
                            flag_mut = false;
                            takenLines2_mut = cons(takenLine2_1, takenLines2);
                            headers_mut = headers;
                            prevRows_mut = prevRows;
                            cur_mut = map((tupledArg_9) => {
                                const _arg = tupledArg_9[0];
                                return cons([_arg[0].trimEnd(), _arg[1]], tupledArg_9[1]);
                            }, zip(parts_1, cur));
                            lines_1_mut = others_1;
                            continue loop;
                        }
                        case 1: {
                            flag_mut = true;
                            takenLines2_mut = cons(takenLine2_2, takenLines2);
                            headers_mut = headers;
                            prevRows_mut = cons(map(reverse, cur), prevRows);
                            cur_mut = emptyCur;
                            lines_1_mut = others_2;
                            continue loop;
                        }
                        case 2: {
                            flag_mut = true;
                            takenLines2_mut = cons(takenLine2_3, takenLines2);
                            headers_mut = map(reverse, cur);
                            prevRows_mut = prevRows;
                            cur_mut = emptyCur;
                            lines_1_mut = others_3;
                            continue loop;
                        }
                        case 3: {
                            if (flag) {
                                return [[headers, alignments, reverse(prevRows)], cons(takenLine, reverse(takenLines2)), lines_1];
                            }
                            else {
                                return void 0;
                            }
                        }
                    }
                    break;
                }
            };
            return loop(true, empty(), void 0, empty(), emptyCur, rest);
        }
        case 1: {
            return void 0;
        }
    }
}

export function $007CBlockquoteStart$007C_$007C(line, n) {
    let inputRecord, StartColumn, EndColumn;
    const match$0027 = match(create("(^ {0,3})\u003e(\\s?)(.*)"), line);
    if (match$0027 != null) {
        const group = match$0027[3];
        const index = (match$0027[1].length + match$0027[2].length) | 0;
        return [group || "", (inputRecord = (new FSharpRef(n)), (StartColumn = ((n.StartColumn + index) | 0), (EndColumn = (((n.StartColumn + index) + group.length) | 0), new MarkdownRange(inputRecord.contents.StartLine, StartColumn, inputRecord.contents.EndLine, EndColumn))))];
    }
    else {
        return void 0;
    }
}

export function $007CTakeParagraphLines$007C_$007C(input) {
    const matchValue = List_partitionWhileLookahead((_arg) => {
        let tupledArg, tupledArg_1;
        return ($007CHeading$007C_$007C(_arg) != null) ? false : (($007CFencedCodeBlock$007C_$007C(_arg) != null) ? false : ((!isEmpty(_arg)) ? ((((tupledArg = head(_arg), $007CBlockquoteStart$007C_$007C(tupledArg[0], tupledArg[1]))) != null) ? false : (!(((tupledArg_1 = head(_arg), StringPosition_$007CWhiteSpace$007C_$007C(tupledArg_1[0], tupledArg_1[1]))) != null))) : true));
    }, input);
    if (!equals(matchValue[0], empty())) {
        return [matchValue[0], matchValue[1]];
    }
    else {
        return void 0;
    }
}

export function $007CHtmlBlock$007C_$007C(lines) {
    let rest, html;
    let pattern_matching_result, _n_1, first_1, html_1, rest_1, takenLine_1;
    if (!isEmpty(lines)) {
        const activePatternResult = $007CTakeParagraphLines$007C_$007C(lines);
        if (activePatternResult != null) {
            if ((rest = activePatternResult[1], (html = activePatternResult[0], head(lines)[0].indexOf("\u003c") === 0))) {
                pattern_matching_result = 0;
                _n_1 = head(lines)[1];
                first_1 = head(lines)[0];
                html_1 = activePatternResult[0];
                rest_1 = activePatternResult[1];
                takenLine_1 = head(lines);
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return [html_1, cons(takenLine_1, html_1), rest_1];
        }
        case 1: {
            return void 0;
        }
    }
}

export function $007CLinesUntilBlockquoteEnds$007C(input) {
    return List_partitionUntilLookahead((next) => {
        let tupledArg, tupledArg_1;
        let pattern_matching_result;
        if (!isEmpty(next)) {
            if (((tupledArg = head(next), $007CBlockquoteStart$007C_$007C(tupledArg[0], tupledArg[1]))) != null) {
                pattern_matching_result = 0;
            }
            else if ($007CHeading$007C_$007C(next) != null) {
                pattern_matching_result = 1;
            }
            else if (((tupledArg_1 = head(next), StringPosition_$007CWhiteSpace$007C_$007C(tupledArg_1[0], tupledArg_1[1]))) != null) {
                pattern_matching_result = 2;
            }
            else {
                pattern_matching_result = 3;
            }
        }
        else if ($007CHeading$007C_$007C(next) != null) {
            pattern_matching_result = 1;
        }
        else {
            pattern_matching_result = 3;
        }
        switch (pattern_matching_result) {
            case 0: {
                return true;
            }
            case 1: {
                return true;
            }
            case 2: {
                return true;
            }
            case 3: {
                return false;
            }
        }
    }, input);
}

export function $007CBlockquote$007C_$007C(lines) {
    let activePatternResult_5, lines_1, rest_2, takenLines_1;
    const activePatternResult = $007CEmptyBlockquote$007C_$007C(lines);
    if (activePatternResult != null) {
        const activePatternResult_1 = Lines_$007CTrimBlankStart$007C(activePatternResult[1]);
        const takenLines = activePatternResult[0];
        return [singleton(["", MarkdownRangeModule_zero]), append_1(takenLines, activePatternResult_1[0]), activePatternResult_1[1]];
    }
    else {
        let pattern_matching_result, continued, quoteLine, rest_1, takenLine, takenLines2_1;
        if (!isEmpty(lines)) {
            let activePatternResult_2;
            const tupledArg = head(lines);
            activePatternResult_2 = $007CBlockquoteStart$007C_$007C(tupledArg[0], tupledArg[1]);
            if (activePatternResult_2 != null) {
                const activePatternResult_3 = $007CLinesUntilBlockquoteEnds$007C(tail(lines));
                const activePatternResult_4 = Lines_$007CTrimBlankStart$007C(activePatternResult_3[1]);
                pattern_matching_result = 0;
                continued = activePatternResult_3[0];
                quoteLine = activePatternResult_2;
                rest_1 = activePatternResult_4[1];
                takenLine = head(lines);
                takenLines2_1 = activePatternResult_4[0];
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
        switch (pattern_matching_result) {
            case 0: {
                const patternInput = (activePatternResult_5 = $007CBlockquote$007C_$007C(rest_1), (activePatternResult_5 != null) ? ((lines_1 = activePatternResult_5[0], (rest_2 = activePatternResult_5[2], (takenLines_1 = activePatternResult_5[1], [lines_1, takenLines_1, rest_2])))) : [empty(), empty(), rest_1]);
                return [append_1(cons(quoteLine, continued), patternInput[0]), append_1(cons(takenLine, continued), append_1(takenLines2_1, patternInput[1])), patternInput[2]];
            }
            case 1: {
                return void 0;
            }
        }
    }
}

export function $007CEmptyBlockquote$007C_$007C(lines) {
    let tupledArg_3, tupledArg_1;
    let pattern_matching_result;
    if (!isEmpty(lines)) {
        let activePatternResult;
        const tupledArg = head(lines);
        activePatternResult = $007CBlockquoteStart$007C_$007C(tupledArg[0], tupledArg[1]);
        if (activePatternResult != null) {
            if (((tupledArg_1 = activePatternResult, StringPosition_$007CWhiteSpace$007C_$007C(tupledArg_1[0], tupledArg_1[1]))) != null) {
                if ($007CBlockquote$007C_$007C(tail(lines)) != null) {
                    pattern_matching_result = 0;
                }
                else {
                    pattern_matching_result = 1;
                }
            }
            else {
                pattern_matching_result = 1;
            }
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return void 0;
        }
        case 1: {
            let pattern_matching_result_1, rest, takenLine;
            if (!isEmpty(lines)) {
                let activePatternResult_3;
                const tupledArg_2 = head(lines);
                activePatternResult_3 = $007CBlockquoteStart$007C_$007C(tupledArg_2[0], tupledArg_2[1]);
                if (activePatternResult_3 != null) {
                    if (((tupledArg_3 = activePatternResult_3, StringPosition_$007CWhiteSpace$007C_$007C(tupledArg_3[0], tupledArg_3[1]))) != null) {
                        pattern_matching_result_1 = 0;
                        rest = tail(lines);
                        takenLine = head(lines);
                    }
                    else {
                        pattern_matching_result_1 = 1;
                    }
                }
                else {
                    pattern_matching_result_1 = 1;
                }
            }
            else {
                pattern_matching_result_1 = 1;
            }
            switch (pattern_matching_result_1) {
                case 0: {
                    return [singleton(takenLine), rest];
                }
                case 1: {
                    return void 0;
                }
            }
        }
    }
}

export function $007CLatexBlock$007C_$007C(lines) {
    let first_1;
    let pattern_matching_result, _takenLine1_1, first_4, n_2, rest_4, first_5, n_3, rest_6, takenLine_3, _n_2, first_6, rest_7, takenLine_4, _n_3, first_7, rest_9, takenLine_5;
    if (!isEmpty(lines)) {
        if (head(lines)[0].trimEnd() === "$$$") {
            pattern_matching_result = 0;
            _takenLine1_1 = head(lines);
            first_4 = head(lines)[0];
            n_2 = head(lines)[1];
            rest_4 = tail(lines);
        }
        else if ((first_1 = head(lines)[0], ((first_1.trimEnd().indexOf("$$") === 0) && endsWith(first_1.trimEnd(), "$$")) && (first_1.trimEnd().length >= 4))) {
            pattern_matching_result = 1;
            first_5 = head(lines)[0];
            n_3 = head(lines)[1];
            rest_6 = tail(lines);
            takenLine_3 = head(lines);
        }
        else if (head(lines)[0].trimEnd() === "\\begin{equation}") {
            pattern_matching_result = 2;
            _n_2 = head(lines)[1];
            first_6 = head(lines)[0];
            rest_7 = tail(lines);
            takenLine_4 = head(lines);
        }
        else if (head(lines)[0].trimEnd() === "\\begin{align}") {
            pattern_matching_result = 3;
            _n_3 = head(lines)[1];
            first_7 = head(lines)[0];
            rest_9 = tail(lines);
            takenLine_5 = head(lines);
        }
        else {
            pattern_matching_result = 4;
        }
    }
    else {
        pattern_matching_result = 4;
    }
    switch (pattern_matching_result) {
        case 0: {
            const activePatternResult = $007CTakeParagraphLines$007C_$007C(rest_4);
            if (activePatternResult != null) {
                const body = activePatternResult[0];
                const rest_5 = activePatternResult[1];
                return ["equation", body, append_1(cons(["\\begin{equation}", n_2], body), singleton(["\\end{equation}", n_2])), rest_5];
            }
            else {
                return void 0;
            }
        }
        case 1: {
            const text = first_5.trimEnd();
            return ["equation", singleton([text.slice(2, (text.length - 3) + 1), n_3]), singleton(takenLine_3), rest_6];
        }
        case 2: {
            const body_1 = takeWhile((s) => (s[0] !== "\\end{equation}"), rest_7);
            const res = skipWhile((s_1) => (s_1[0] !== "\\end{equation}"), rest_7);
            if (isEmpty(res)) {
                return void 0;
            }
            else {
                return ["equation", body_1, cons(takenLine_4, body_1), tail(res)];
            }
        }
        case 3: {
            const body_2 = takeWhile((s_2) => (s_2[0] !== "\\end{align}"), rest_9);
            const res_1 = skipWhile((s_3) => (s_3[0] !== "\\end{align}"), rest_9);
            if (isEmpty(res_1)) {
                return void 0;
            }
            else {
                return ["align", body_2, cons(takenLine_5, body_2), tail(res_1)];
            }
        }
        case 4: {
            return void 0;
        }
    }
}

export function $007CLinkDefinition$007C_$007C(s) {
    let pattern_matching_result, line, link, rest, wrapped;
    if (!isEmpty(s)) {
        let activePatternResult;
        const tupledArg = ["[", "]:"];
        const tupledArg_1 = head(s);
        activePatternResult = StringPosition_$007CStartsWithWrapped$007C_$007C(tupledArg[0], tupledArg[1], tupledArg_1[0], tupledArg_1[1]);
        if (activePatternResult != null) {
            let activePatternResult_1;
            const tupledArg_2 = activePatternResult[1];
            activePatternResult_1 = StringPosition_$007CTrimBoth$007C(tupledArg_2[0], tupledArg_2[1]);
            pattern_matching_result = 0;
            line = head(s);
            link = activePatternResult_1;
            rest = tail(s);
            wrapped = activePatternResult[0];
        }
        else {
            let activePatternResult_2;
            const tupledArg_3 = [" [", "]:"];
            const tupledArg_4 = head(s);
            activePatternResult_2 = StringPosition_$007CStartsWithWrapped$007C_$007C(tupledArg_3[0], tupledArg_3[1], tupledArg_4[0], tupledArg_4[1]);
            if (activePatternResult_2 != null) {
                let activePatternResult_3;
                const tupledArg_5 = activePatternResult_2[1];
                activePatternResult_3 = StringPosition_$007CTrimBoth$007C(tupledArg_5[0], tupledArg_5[1]);
                pattern_matching_result = 0;
                line = head(s);
                link = activePatternResult_3;
                rest = tail(s);
                wrapped = activePatternResult_2[0];
            }
            else {
                let activePatternResult_4;
                const tupledArg_6 = ["  [", "]:"];
                const tupledArg_7 = head(s);
                activePatternResult_4 = StringPosition_$007CStartsWithWrapped$007C_$007C(tupledArg_6[0], tupledArg_6[1], tupledArg_7[0], tupledArg_7[1]);
                if (activePatternResult_4 != null) {
                    let activePatternResult_5;
                    const tupledArg_8 = activePatternResult_4[1];
                    activePatternResult_5 = StringPosition_$007CTrimBoth$007C(tupledArg_8[0], tupledArg_8[1]);
                    pattern_matching_result = 0;
                    line = head(s);
                    link = activePatternResult_5;
                    rest = tail(s);
                    wrapped = activePatternResult_4[0];
                }
                else {
                    let activePatternResult_6;
                    const tupledArg_9 = ["   [", "]:"];
                    const tupledArg_10 = head(s);
                    activePatternResult_6 = StringPosition_$007CStartsWithWrapped$007C_$007C(tupledArg_9[0], tupledArg_9[1], tupledArg_10[0], tupledArg_10[1]);
                    if (activePatternResult_6 != null) {
                        let activePatternResult_7;
                        const tupledArg_11 = activePatternResult_6[1];
                        activePatternResult_7 = StringPosition_$007CTrimBoth$007C(tupledArg_11[0], tupledArg_11[1]);
                        pattern_matching_result = 0;
                        line = head(s);
                        link = activePatternResult_7;
                        rest = tail(s);
                        wrapped = activePatternResult_6[0];
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
            }
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return [[wrapped, link], singleton(line), rest];
        }
        case 1: {
            return void 0;
        }
    }
}

export function updateCurrentRange(lines) {
    if (!isEmpty(lines)) {
        return some(head(lines)[1]);
    }
    else {
        return void 0;
    }
}

export function parseParagraphs(ctx, lines) {
    return delay(() => {
        let activePatternResult, loc, rest, yaml, matchValue;
        const ctx_1 = new ParsingContext(ctx.Links, ctx.Newline, ctx.IsFirst, updateCurrentRange(lines), ctx.ParseOptions);
        const patternInput = (ctx_1.IsFirst && ParsingContext__get_AllowYamlFrontMatter(ctx_1)) ? ((activePatternResult = $007CYamlFrontmatter$007C_$007C(lines), (activePatternResult != null) ? ((loc = activePatternResult[1], (rest = activePatternResult[2], (yaml = activePatternResult[0], [new MarkdownParagraph(12, yaml, loc), rest])))) : [void 0, lines])) : [void 0, lines];
        const moreLines = Lines_$007CTrimBlankStart$007C(patternInput[1])[1];
        return append((matchValue = patternInput[0], (matchValue != null) ? singleton_1(matchValue) : ((empty_1()))), delay(() => {
            let tree, nestUnmatchingItems, formatTree, unifySimpleProperty, takenLines_7, all;
            const ctx_2 = new ParsingContext(ctx_1.Links, ctx_1.Newline, ctx_1.IsFirst, updateCurrentRange(moreLines), ctx_1.ParseOptions);
            const ctx_3 = new ParsingContext(ctx_2.Links, ctx_2.Newline, false, ctx_2.CurrentRange, ctx_2.ParseOptions);
            const matchValue_1 = moreLines;
            const activePatternResult_2 = $007CLinkDefinition$007C_$007C(matchValue_1);
            if (activePatternResult_2 != null) {
                const activePatternResult_3 = Lines_$007CTrimBlankStart$007C(activePatternResult_2[2]);
                const key = activePatternResult_2[0][0];
                const link = activePatternResult_2[0][1];
                const takenLines = activePatternResult_2[1];
                return append(ParsingContext__get_ParseNonCodeAsOther(ctx_3) ? singleton_1(new MarkdownParagraph(10, append_1(takenLines, activePatternResult_3[0]), ctx_3.CurrentRange)) : append(ctx_3.Links.has(key) ? ((toFail(printf("Cannot define a link to the reference %s twice."))(key), empty_1())) : empty_1(), delay(() => {
                    addToDict(ctx_3.Links, key, getLinkAndTitle(link[0], link[1]));
                    return empty_1();
                })), delay(() => parseParagraphs(ctx_3, activePatternResult_3[1])));
            }
            else {
                let pattern_matching_result, code, ignoredLine, langString, lines_2, takenLines_1, takenLines2_1;
                const activePatternResult_4 = $007CNestedCodeBlock$007C_$007C(matchValue_1);
                if (activePatternResult_4 != null) {
                    const activePatternResult_5 = Lines_$007CTrimBlankStart$007C(activePatternResult_4[2]);
                    pattern_matching_result = 0;
                    code = activePatternResult_4[0];
                    ignoredLine = activePatternResult_4[4];
                    langString = activePatternResult_4[3];
                    lines_2 = activePatternResult_5[1];
                    takenLines_1 = activePatternResult_4[1];
                    takenLines2_1 = activePatternResult_5[0];
                }
                else {
                    const activePatternResult_6 = $007CFencedCodeBlock$007C_$007C(matchValue_1);
                    if (activePatternResult_6 != null) {
                        const activePatternResult_7 = Lines_$007CTrimBlankStart$007C(activePatternResult_6[2]);
                        pattern_matching_result = 0;
                        code = activePatternResult_6[0];
                        ignoredLine = activePatternResult_6[4];
                        langString = activePatternResult_6[3];
                        lines_2 = activePatternResult_7[1];
                        takenLines_1 = activePatternResult_6[1];
                        takenLines2_1 = activePatternResult_7[0];
                    }
                    else {
                        pattern_matching_result = 1;
                    }
                }
                switch (pattern_matching_result) {
                    case 0: {
                        return append(ParsingContext__get_ParseCodeAsOther(ctx_3) ? singleton_1(new MarkdownParagraph(10, append_1(takenLines_1, takenLines2_1), ctx_3.CurrentRange)) : singleton_1(new MarkdownParagraph(2, join(ctx_3.Newline, code), void 0, langString, ignoredLine, ctx_3.CurrentRange)), delay(() => parseParagraphs(ctx_3, lines_2)));
                    }
                    case 1: {
                        const activePatternResult_8 = $007CBlockquote$007C_$007C(matchValue_1);
                        if (activePatternResult_8 != null) {
                            const activePatternResult_9 = Lines_$007CTrimBlankStart$007C(activePatternResult_8[2]);
                            const body = activePatternResult_8[0];
                            const takenLines_2 = activePatternResult_8[1];
                            return append(ParsingContext__get_ParseNonCodeAsOther(ctx_3) ? singleton_1(new MarkdownParagraph(10, append_1(takenLines_2, activePatternResult_9[0]), ctx_3.CurrentRange)) : singleton_1(new MarkdownParagraph(5, ofSeq(parseParagraphs(ctx_3, append_1(body, singleton(["", MarkdownRangeModule_zero])))), ctx_3.CurrentRange)), delay(() => parseParagraphs(ctx_3, activePatternResult_9[1])));
                        }
                        else {
                            let pattern_matching_result_1, alignments, headers, rest_2, rows, takenLines_3, takenLines2_3;
                            const activePatternResult_10 = $007CEmacsTableBlock$007C_$007C(matchValue_1);
                            if (activePatternResult_10 != null) {
                                const activePatternResult_11 = Lines_$007CTrimBlankStart$007C(activePatternResult_10[2]);
                                pattern_matching_result_1 = 0;
                                alignments = activePatternResult_10[0][1];
                                headers = activePatternResult_10[0][0];
                                rest_2 = activePatternResult_11[1];
                                rows = activePatternResult_10[0][2];
                                takenLines_3 = activePatternResult_10[1];
                                takenLines2_3 = activePatternResult_11[0];
                            }
                            else {
                                const activePatternResult_12 = $007CPipeTableBlock$007C_$007C(matchValue_1);
                                if (activePatternResult_12 != null) {
                                    const activePatternResult_13 = Lines_$007CTrimBlankStart$007C(activePatternResult_12[2]);
                                    pattern_matching_result_1 = 0;
                                    alignments = activePatternResult_12[0][1];
                                    headers = activePatternResult_12[0][0];
                                    rest_2 = activePatternResult_13[1];
                                    rows = activePatternResult_12[0][2];
                                    takenLines_3 = activePatternResult_12[1];
                                    takenLines2_3 = activePatternResult_13[0];
                                }
                                else {
                                    pattern_matching_result_1 = 1;
                                }
                            }
                            switch (pattern_matching_result_1) {
                                case 0: {
                                    return append(ParsingContext__get_ParseNonCodeAsOther(ctx_3) ? singleton_1(new MarkdownParagraph(10, append_1(takenLines_3, takenLines2_3), ctx_3.CurrentRange)) : singleton_1(new MarkdownParagraph(9, (headers == null) ? (void 0) : map((i) => ofSeq(parseParagraphs(ctx_3, i)), value_14(headers)), alignments, map((list_1) => map((i_1) => ofSeq(parseParagraphs(ctx_3, i_1)), list_1), rows), ctx_3.CurrentRange)), delay(() => parseParagraphs(ctx_3, rest_2)));
                                }
                                case 1: {
                                    let pattern_matching_result_2, c, lines_3, takenLine, takenLines2_4;
                                    if (!isEmpty(matchValue_1)) {
                                        let activePatternResult_14;
                                        const tupledArg = head(matchValue_1);
                                        activePatternResult_14 = $007CHorizontalRule$007C_$007C(tupledArg[0], tupledArg[1]);
                                        if (activePatternResult_14 != null) {
                                            const activePatternResult_15 = Lines_$007CTrimBlankStart$007C(tail(matchValue_1));
                                            pattern_matching_result_2 = 0;
                                            c = activePatternResult_14;
                                            lines_3 = activePatternResult_15[1];
                                            takenLine = head(matchValue_1);
                                            takenLines2_4 = activePatternResult_15[0];
                                        }
                                        else {
                                            pattern_matching_result_2 = 1;
                                        }
                                    }
                                    else {
                                        pattern_matching_result_2 = 1;
                                    }
                                    switch (pattern_matching_result_2) {
                                        case 0: {
                                            return append(ParsingContext__get_ParseNonCodeAsOther(ctx_3) ? singleton_1(new MarkdownParagraph(10, cons(takenLine, takenLines2_4), ctx_3.CurrentRange)) : singleton_1(new MarkdownParagraph(8, c, ctx_3.CurrentRange)), delay(() => parseParagraphs(ctx_3, lines_3)));
                                        }
                                        case 1: {
                                            const activePatternResult_16 = $007CLatexBlock$007C_$007C(matchValue_1);
                                            if (activePatternResult_16 != null) {
                                                const activePatternResult_17 = Lines_$007CTrimBlankStart$007C(activePatternResult_16[3]);
                                                const body_1 = activePatternResult_16[1];
                                                const env = activePatternResult_16[0];
                                                const takenLines_4 = activePatternResult_16[2];
                                                return append(ParsingContext__get_ParseNonCodeAsOther(ctx_3) ? singleton_1(new MarkdownParagraph(10, append_1(takenLines_4, activePatternResult_17[0]), ctx_3.CurrentRange)) : singleton_1(new MarkdownParagraph(7, env, map((tuple) => tuple[0], body_1), ctx_3.CurrentRange)), delay(() => parseParagraphs(ctx_3, activePatternResult_17[1])));
                                            }
                                            else {
                                                const activePatternResult_18 = $007CListItems$007C_$007C(true, matchValue_1);
                                                if (activePatternResult_18 != null) {
                                                    const activePatternResult_19 = Lines_$007CTrimBlankStart$007C(activePatternResult_18[2]);
                                                    const items = activePatternResult_18[0];
                                                    const takenLines_5 = activePatternResult_18[1];
                                                    return append(ParsingContext__get_ParseNonCodeAsOther(ctx_3) ? singleton_1(new MarkdownParagraph(10, append_1(takenLines_5, activePatternResult_19[0]), ctx_3.CurrentRange)) : ((tree = Tree_ofIndentedList(items), (nestUnmatchingItems = ((items_1) => {
                                                        if (isEmpty(items_1)) {
                                                            return empty();
                                                        }
                                                        else {
                                                            return map((tupledArg_1) => {
                                                                const _arg_1 = tupledArg_1[0];
                                                                return new Tree$1(0, _arg_1.fields[0], append_1(nestUnmatchingItems(_arg_1.fields[1]), tupledArg_1[1]));
                                                            }, List_nestUnderLastMatching((_arg) => equals(_arg.fields[0][1], head(items_1).fields[0][1]), items_1));
                                                        }
                                                    }), (formatTree = ((nodes) => (new MarkdownParagraph(4, (!isEmpty(nodes)) ? head(nodes).fields[0][1] : (new MarkdownListKind(1)), toList(delay(() => collect((matchValue_2) => {
                                                        const nested_1 = matchValue_2.fields[1];
                                                        const body_2 = matchValue_2.fields[0][2];
                                                        return singleton_1(toList(delay(() => {
                                                            const rng = MarkdownRangeModule_mergeRanges(map((tuple_1) => tuple_1[1], body_2));
                                                            return append((!matchValue_2.fields[0][0]) ? parseParagraphs(ctx_3, body_2) : singleton_1(new MarkdownParagraph(6, parseSpans(join(ctx_3.Newline, map((tuple_2) => tuple_2[0], body_2)), rng, ctx_3), ctx_3.CurrentRange)), delay(() => ((!equals(nested_1, empty())) ? singleton_1(formatTree(nested_1)) : empty_1())));
                                                        })));
                                                    }, nodes))), ctx_3.CurrentRange))), (unifySimpleProperty = ((nodes_1) => {
                                                        if (exists((_arg_2) => {
                                                            if (_arg_2.fields[0][0]) {
                                                                return false;
                                                            }
                                                            else {
                                                                return true;
                                                            }
                                                        }, tree)) {
                                                            return map((_arg_3) => (new Tree$1(0, [false, _arg_3.fields[0][1], _arg_3.fields[0][2]], unifySimpleProperty(_arg_3.fields[1]))), nodes_1);
                                                        }
                                                        else {
                                                            return nodes_1;
                                                        }
                                                    }), singleton_1(formatTree(unifySimpleProperty(tree)))))))), delay(() => parseParagraphs(ctx_3, activePatternResult_19[1])));
                                                }
                                                else {
                                                    const activePatternResult_20 = $007CHeading$007C_$007C(matchValue_1);
                                                    if (activePatternResult_20 != null) {
                                                        const activePatternResult_21 = Lines_$007CTrimBlankStart$007C(activePatternResult_20[3]);
                                                        const body_3 = activePatternResult_20[1];
                                                        const n = activePatternResult_20[0] | 0;
                                                        const takenLines_6 = activePatternResult_20[2];
                                                        return append(ParsingContext__get_ParseNonCodeAsOther(ctx_3) ? singleton_1(new MarkdownParagraph(10, append_1(takenLines_6, activePatternResult_21[0]), ctx_3.CurrentRange)) : singleton_1(new MarkdownParagraph(0, n, parseSpans(body_3[0], body_3[1], ctx_3), ctx_3.CurrentRange)), delay(() => parseParagraphs(ctx_3, activePatternResult_21[1])));
                                                    }
                                                    else {
                                                        let pattern_matching_result_3, code_3, lines_6, takenLines_8, takenLines2_9;
                                                        const activePatternResult_22 = $007CHtmlBlock$007C_$007C(matchValue_1);
                                                        if (activePatternResult_22 != null) {
                                                            const activePatternResult_23 = Lines_$007CTrimBlankStart$007C(activePatternResult_22[2]);
                                                            if ((takenLines_7 = activePatternResult_22[1], (all = join(ctx_3.Newline, map((tuple_3) => tuple_3[0], activePatternResult_22[0])), ((!(all.indexOf("\u003chttp://") === 0)) && (!(all.indexOf("\u003cftp://") === 0))) && (!(all.indexOf("@") >= 0))))) {
                                                                pattern_matching_result_3 = 0;
                                                                code_3 = activePatternResult_22[0];
                                                                lines_6 = activePatternResult_23[1];
                                                                takenLines_8 = activePatternResult_22[1];
                                                                takenLines2_9 = activePatternResult_23[0];
                                                            }
                                                            else {
                                                                pattern_matching_result_3 = 1;
                                                            }
                                                        }
                                                        else {
                                                            pattern_matching_result_3 = 1;
                                                        }
                                                        switch (pattern_matching_result_3) {
                                                            case 0: {
                                                                return append(ParsingContext__get_ParseNonCodeAsOther(ctx_3) ? singleton_1(new MarkdownParagraph(10, append_1(takenLines_8, takenLines2_9), ctx_3.CurrentRange)) : singleton_1(new MarkdownParagraph(3, join(ctx_3.Newline, map((tuple_4) => tuple_4[0], code_3)), void 0, ctx_3.CurrentRange)), delay(() => parseParagraphs(ctx_3, lines_6)));
                                                            }
                                                            case 1: {
                                                                const activePatternResult_24 = $007CTakeParagraphLines$007C_$007C(matchValue_1);
                                                                if (activePatternResult_24 != null) {
                                                                    const activePatternResult_25 = Lines_$007CTrimParagraphLines$007C(activePatternResult_24[0]);
                                                                    const activePatternResult_26 = Lines_$007CTrimBlankStart$007C(activePatternResult_24[1]);
                                                                    const takenLines_9 = activePatternResult_24[0];
                                                                    return append(ParsingContext__get_ParseNonCodeAsOther(ctx_3) ? singleton_1(new MarkdownParagraph(10, append_1(takenLines_9, activePatternResult_26[0]), ctx_3.CurrentRange)) : singleton_1(new MarkdownParagraph(1, parseSpans(join(ctx_3.Newline, map((tuple_5) => tuple_5[0], activePatternResult_25)), MarkdownRangeModule_mergeRanges(map((tuple_6) => tuple_6[1], activePatternResult_25)), ctx_3), ctx_3.CurrentRange)), delay(() => parseParagraphs(ctx_3, activePatternResult_26[1])));
                                                                }
                                                                else {
                                                                    const activePatternResult_27 = Lines_$007CTrimBlankStart$007C(matchValue_1);
                                                                    if (isEmpty(activePatternResult_27[1])) {
                                                                        return empty_1();
                                                                    }
                                                                    else {
                                                                        toFail(printf("Unexpectedly stopped!\n%A"))(moreLines);
                                                                        return empty_1();
                                                                    }
                                                                }
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }));
    });
}

